import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  Grid,
  TextField,
  styled,
  Switch,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  FormHelperText,
  Typography,
  Chip,
  TextareaAutosize,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  RadioGroup,
  Radio,
} from "@mui/material";
import { React, useRef, useEffect, useState } from "react";
import BrowseUploadButton from "../../common/button/browseUploadButton";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import PrintDownloadButton from "../../common/button/printDownloadButton";
import { MdOutlineEdit } from "react-icons/md";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";
import BackButton from "../../common/button/backButton";
import PreRequisiteModal from "./preRequisiteModal";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { FaPlus } from "react-icons/fa";
import MasterModel from "../createMaster/masterModel";
import { useDispatch, useSelector } from "react-redux";
import masterFormsActions from "../../redux/masterForms/actions";
import masterActions from "../../redux/master/actions";
import dayjs from "dayjs";
import pdf from "../../assets/images/uploads/pdf.png";
import { PiX, PiXBold } from "react-icons/pi";
import Prerequesite from "./preRequesite";
import { IoCloudUploadOutline } from "react-icons/io5";
import { NumbersValidation } from "../../utils/validation";
import commonActions from "../../redux/common/actions";
import CreateMasterModal from "../masterForm/modals/createMasterModal";
import JSZip from "jszip";
import { jsPDF } from "jspdf";
// import mammoth from "mammoth";
import { API_URL } from "../../utils/constants";
import axios from "axios";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import DocViewer from "@cyntler/react-doc-viewer";
import { BsDownload } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import modifyWordFileCard from "../../common/wordFilemodify";
import image from "../../assets/images/image.png";
import Barcode from "react-barcode";
import eligibilityCriteriaActions from "../../redux/eligibilityCriteria/actions";
import courseActions from "../../redux/course/actions";
export default function AddCourse() {
  const navigate = useNavigate();
  const location = useLocation();
  let id = location?.state?.id;
  const now = new Date();
  const dispatch = useDispatch();
  const today = new Date();
  const [message, setMessage] = useState("");
  const [replacements, setReplacements] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [modifiedFileUrl, setModifiedFileUrl] = useState(null);
  const documents = modifiedFileUrl;
  const [file, setFile] = useState(null);
  const [scorecard, setScorecard] = useState(null);
  const [uploadfile, setUploadedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [fileName, setFileName] = useState("");
  const [ScordCardFileName, setScordCardFileName] = useState("");
  const [ScoreUploadedFile, setScoreUploadedFile] = useState(null);
  const [ipAddress, setIpAddress] = useState(null);
  const [showIframe, setShowIframe] = useState(false);
  const [metadata, setMetaData] = useState(false);
  const [showScoredata, setShowScoredata] = useState(false);
  const { coursecandidatelist } = useSelector((state) => state.masterReducer);
  const { mothertongueList } = useSelector((state) => state.masterFormsReducer);
  const { genderList } = useSelector((state) => state.masterFormsReducer);
  const targetApplicantId = coursecandidatelist?.[0]?.applicantid;
  const filteredResults = coursecandidatelist?.filter(
    (item) => item.applicantid === targetApplicantId
  );
  const barcodeRef = useRef(null);
  const [barcodeDataUrl, setBarcodeDataUrl] = useState("");

  const candidateid = coursecandidatelist?.[0]?.candidateid;

  useEffect(() => {
    if (barcodeRef.current) {
      const svgElement = barcodeRef.current.querySelector("svg");

      if (svgElement) {
        const svgString = new XMLSerializer().serializeToString(svgElement);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();

        const svgBlob = new Blob([svgString], {
          type: "image/svg+xml;charset=utf-8",
        });
        const url = URL.createObjectURL(svgBlob);

        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);
          const dataUrl = canvas.toDataURL("image/png");
          setBarcodeDataUrl(dataUrl);
          URL.revokeObjectURL(url);
        };

        img.src = url;
      }
    }
  }, [candidateid]);
  const candidate = coursecandidatelist?.find(
    (item) => item.candidateid === candidateid
  );
  const formatTime = (timeString) => {
    if (!timeString) return "";

    let [hh, mm] = timeString.split(":").map(Number);
    const period = hh >= 12 ? "PM" : "AM";

    hh = hh % 12 || 12;

    return `${hh}:${mm.toString().padStart(2, "0")} ${period}`;
  };
  const isoDate = now.toISOString().split("T")[0];
  const isoTime = now.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const formatDate1 = (dateString) => {
    if (!dateString) return "";
    const [yyyy, mm, dd] = dateString.split("-");
    return `${dd}/${mm}/${yyyy}`;
  };
  const placeholders = [
    {
      originalText: "<name>",
      replaceText: /<name>/g,
      value: filteredResults?.[0]?.candidatename,
      Name: "Candidate’s Full Name",
    },
    {
      originalText: "<rollno>",
      replaceText: /<rollno>/g,
      value: filteredResults?.[0]?.rollno,
      Name: "Roll Number",
    },
    {
      originalText: "<gender>",
      replaceText: /<gender>/g,
      value: filteredResults?.[0]?.gender,
      Name: "Gender",
    },
    {
      originalText: "<appno>",
      replaceText: /<appno>/g,
      value: filteredResults?.[0]?.applicantid,
      Name: "Application Number",
    },
    {
      originalText: "<examtime>",
      replaceText: /<examtime>/g,
      value: formatTime(filteredResults?.[0]?.starttime),
      Name: "Exam Start Time",
    },
    {
      originalText: "<lang>",
      replaceText: /<lang>/g,
      value: filteredResults?.[0]?.languagename,
      Name: "Question Paper Language",
    },
    {
      originalText: "<examdate>",
      replaceText: /<examdate>/g,
      value: formatDate1(filteredResults?.[0]?.examdate),
      Name: "Date of Examination",
    },
    {
      originalText: "<dob>",
      replaceText: /<dob>/g,
      value: formatDate1(filteredResults?.[0]?.dob),
      Name: "Date of Birth",
    },
    {
      originalText: "<disability>",
      replaceText: /<disability>/g,
      value: filteredResults?.[0]?.isdisability == 1 ? "Yes" : "No",
      Name: "Person with Disability (PWD)",
    },
    {
      originalText: "<disabilitytype>",
      replaceText: /<disabilitytype>/g,
      value: filteredResults?.[0]?.disabilitytype,
      Name: "Disability Type",
    },
    {
      originalText: "<isextratime>",
      replaceText: /<isextratime>/g,
      value: filteredResults?.[0]?.isextratime == 1 ? "Yes" : "No",
      Name: "Extra Time Required",
    },
    {
      originalText: "<ipaddress>",
      replaceText: /<ipaddress>/g,
      value: ipAddress,
      Name: "IP Address",
    },
    {
      originalText: "<date>",
      replaceText: /<date>/g,
      value: formatDate1(isoDate),
      Name: showScoredata
        ? "Date of download of Score Card"
        : "Date of download of Admit Card",
    },
    {
      originalText: "<time>",
      replaceText: /<time>/g,
      value: formatTime(isoTime),
      Name: showScoredata
        ? "Time of download of Score Card"
        : "Time of download of Admit Card",
    },
    {
      originalText: "<coursename>",
      replaceText: /<coursename>/g,
      value: filteredResults?.[0]?.coursename,
      Name: "Course Name",
    },
    {
      originalText: "<scribe>",
      replaceText: /<scribe>/g,
      value: filteredResults?.[0]?.isscribe == 1 ? "Yes" : "No",
      Name: "Scribe Required",
    },
    {
      originalText: "<venuecode>",
      replaceText: /<venuecode>/g,
      value: filteredResults?.[0]?.referenceid,
      Name: "Venue Code",
    },
    {
      originalText: "<venueaddress>",
      replaceText: /<venueaddress>/g,
      value: filteredResults?.[0]?.address1,
      Name: "Venue Address",
    },
    {
      originalText: "<reptime>",
      replaceText: /<reptime>/g,
      value: formatTime(filteredResults?.[0]?.reportingtime),
      Name: "Reporting Time at the CET Examination Centre",
    },
    {
      originalText: "<closuretime>",
      replaceText: /<closuretime>/g,
      value: formatTime(filteredResults?.[0]?.endtime),
      Name: "Gate Closure Time",
    },
    // { originalText: "<barcode>", replaceText: /<barcode>/g, value:<Barcode value="barcode-example" />, Name: "Barcode" }
  ];
  const placeholders1 = [
    {
      originalText: "<name>",
      replaceText: /<name>/g,
      value: filteredResults?.[0]?.candidatename,
      Name: "Candidate’s Full Name",
    },
    {
      originalText: "<rollno>",
      replaceText: /<rollno>/g,
      value: filteredResults?.[0]?.rollno,
      Name: "Roll Number",
    },
    {
      originalText: "<gender>",
      replaceText: /<gender>/g,
      value: filteredResults?.[0]?.gender,
      Name: "Gender",
    },
    {
      originalText: "<appno>",
      replaceText: /<appno>/g,
      value: filteredResults?.[0]?.applicantid,
      Name: "Application Number",
    },
    {
      originalText: "<examtime>",
      replaceText: /<examtime>/g,
      value: formatTime(filteredResults?.[0]?.starttime),
      Name: "Exam Start Time",
    },
    {
      originalText: "<lang>",
      replaceText: /<lang>/g,
      value: filteredResults?.[0]?.languagename,
      Name: "Question Paper Language",
    },
    {
      originalText: "<examdate>",
      replaceText: /<examdate>/g,
      value: formatDate1(filteredResults?.[0]?.examdate),
      Name: "Date of Examination",
    },
    {
      originalText: "<dob>",
      replaceText: /<dob>/g,
      value: formatDate1(filteredResults?.[0]?.dob),
      Name: "Date of Birth",
    },
    {
      originalText: "<disability>",
      replaceText: /<disability>/g,
      value: filteredResults?.[0]?.isdisability == 1 ? "Yes" : "No",
      Name: "Person with Disability (PWD)",
    },
    {
      originalText: "<disabilitytype>",
      replaceText: /<disabilitytype>/g,
      value: filteredResults?.[0]?.disabilitytype,
      Name: "Disability Type",
    },
    {
      originalText: "<isextratime>",
      replaceText: /<isextratime>/g,
      value: filteredResults?.[0]?.isextratime == 1 ? "Yes" : "No",
      Name: "Extra Time Required",
    },
    {
      originalText: "<ipaddress>",
      replaceText: /<ipaddress>/g,
      value: ipAddress,
      Name: "IP Address",
    },
    {
      originalText: "<date>",
      replaceText: /<date>/g,
      value: formatDate1(isoDate),
      Name: showScoredata
        ? "Date of download of Score Card"
        : "Date of download of Admit Card",
    },
    {
      originalText: "<time>",
      replaceText: /<time>/g,
      value: formatTime(isoTime),
      Name: showScoredata
        ? "Time of download of Score Card"
        : "Time of download of Admit Card",
    },
    {
      originalText: "<coursename>",
      replaceText: /<coursename>/g,
      value: filteredResults?.[0]?.coursename,
      Name: "Course Name",
    },
    {
      originalText: "<scribe>",
      replaceText: /<scribe>/g,
      value: filteredResults?.[0]?.isscribe == 1 ? "Yes" : "No",
      Name: "Scribe Required",
    },
    {
      originalText: "<venuecode>",
      replaceText: /<venuecode>/g,
      value: filteredResults?.[0]?.referenceid,
      Name: "Venue Code",
    },
    {
      originalText: "<venueaddress>",
      replaceText: /<venueaddress>/g,
      value: filteredResults?.[0]?.address1,
      Name: "Venue Address",
    },
    {
      originalText: "<physics>",
      replaceText: /<physics>/g,
      value: "61",
      Name: "Physics",
    },
    {
      originalText: "<chemistry>",
      replaceText: /<chemistry>/g,
      value: "66",
      Name: "Chemistry",
    },
    {
      originalText: "<biology>",
      replaceText: /<biology>/g,
      value: "66",
      Name: "Biology",
    },
    {
      originalText: "<nursing>",
      replaceText: /<nursing>/g,
      value: "66",
      Name: "Nursing",
    },
    {
      originalText: "<totalscore>",
      replaceText: /<totalscore>/g,
      value: "66",
      Name: "Totalscore",
    },
    {
      originalText: "<english>",
      replaceText: /<english>/g,
      value: "66",
      Name: "English",
    },
    {
      originalText: "<percentile>",
      replaceText: /<percentile>/g,
      value: filteredResults?.[0]?.percentage,
      Name: "Percentage",
    },
    {
      originalText: "<dateofresult>",
      replaceText: /<dateofresult>/g,
      value: formatDate1(filteredResults?.[0]?.scorecardstartdate),
      Name: "Date of result",
    }, // { originalText: "<image>",Name:"Photo" },
  ];

  const handleFileUpload = (e) => {
    setMessage("");
    const uploadedFile = e.target.files[0];
    setUploadedFile(e.target.files[0]);
    setFile(uploadedFile);
    setFileName(uploadedFile ? uploadedFile.name : "");
  };
  const handleScoreCardFileUpload = (e) => {
    setMessage("");
    const uploadedFile = e.target.files[0];
    setScoreUploadedFile(e.target.files[0]);
    setScorecard(uploadedFile);
    setScordCardFileName(uploadedFile ? uploadedFile.name : "");
  };
  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch("https://api.ipify.org?format=json");
        const data = await response.json();
        setIpAddress(data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIpAddress();
  }, []);


  useEffect(() => {
    dispatch({ type: masterFormsActions.GET_MOTHERTONGUE });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch({ type: masterFormsActions.GET_GENDER });
    //eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (id) {
      dispatch({
        type: masterActions.GET_COURSE_CANDIDATE_LIST,
        payload: { courseid: id, candidateid: 0 },
      });
      dispatch({
        type: courseActions.GET_MOCK_DETAILS,
        payload: {
          courseid: id,
        },
      });
    }
  }, [dispatch, id]);

  const isValidUrl = (str) => {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // Protocol
      "([A-Z0-9](?:[A-Z0-9-]*[A-Z0-9])?\\.)+[A-Z0-9](?:[A-Z0-9-]*[A-Z0-9])?" + // Domain name
      "(\\:[0-9]+)?" + // Optional port
      "(\\/[-A-Z0-9+&@#/%=~_|$?!,.;]*)*" + // Path
      "(\\?[;&A-Z0-9+&@#/%=~_|$]*)?" + // Query string
      "(\\#[-A-Z0-9_]*)?$",
      "i"
    ); // Fragment locator
    return pattern.test(str);
  };
  // const uploadFile = async (file) => {

  //   const formData = new FormData();
  //   formData.append("docs", file);

  //   try {
  //     const response = await axios.post(
  //       `${API_URL}/master/coursemanagement/docs`,
  //       formData
  //     );
  //     dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
  //     setIsDialogOpen(true);
  //     setMetaData(false)
  //     setPreview(response.data?.result);
  //     setShowIframe(true)
  //   } catch (error) {
  //     console.error("Error uploading file:", error);
  //   }
  // };
  // const placeholders = [
  //   { originalText: "<name>", replaceText: /<name>/g, value: filteredResults?.[0]?.candidatename,Name:"Candidate’s Full Name" },
  //   { originalText: "<rollno>", replaceText: /<rollno>/g, value: filteredResults?.[0]?.rollno,Name:"Roll Number/User Name" },
  //   { originalText: "<gender>", replaceText: /<gender>/g, value: filteredResults?.[0]?.gender,Name:"Gender" },
  //   { originalText: "<appno>", replaceText: /<appno>/g, value: filteredResults?.[0]?.applicantid,Name:"Application Number" },
  //   { originalText: "<examtime>", replaceText: /<examtime>/g, value: filteredResults?.[0]?.endtime,Name:"Reporting Time at the CET examination Centre" },
  //   { originalText: "<reptime>", replaceText: /<reptime>/g, value: filteredResults?.[0]?.reportingtime,Name:"Roll Number/User Name" },
  //   { originalText: "<closuretime>", replaceText: /<closuretime>/g, value: filteredResults?.[0]?.endtime,Name:"Gate Closure Time" },
  //   { originalText: "<lang>", replaceText: /<lang>/g, value: filteredResults?.[0]?.languagename,Name:"Question Paper Language" },
  //   { originalText: "<examdate>", replaceText: /<examdate>/g, value: filteredResults?.[0]?.examdate,Name:"Date of CET Examination" },
  //   { originalText: "<dob>", replaceText: /<dob>/g, value: filteredResults?.[0]?.dob,Name:"DOB/Password" },
  //   { originalText: "<disability>", replaceText: /<disability>/g, value: filteredResults?.[0]?.isdisability == 0 ? "Yes" : "No" ,Name:"Person with Disability (PWD)"},
  //   { originalText: "<disabilitytype>", replaceText: /<disabilitytype>/g, value: filteredResults?.[0]?.disabilitytype,Name:"Disability Type" },
  //   { originalText: "<isextratime>", replaceText: /<isextratime>/g, value: filteredResults?.[0]?.isextratime,Name:"Extra Time Required" },
  //   { originalText: "<ipaddress>", replaceText: /<ipaddress>/g, value: ipAddress,Name:"Ip Address" },
  //   { originalText: "<date>", replaceText: /<date>/g, value: now.toLocaleDateString(),Name:"Date" },
  //   { originalText: "<time>", replaceText: /<time>/g, value: now.toLocaleTimeString(),Name:"Time" },
  //   { originalText: "<coursename>", replaceText: /<coursename>/g, value: filteredResults?.[0]?.coursename,Name:"Course name" },
  //   { originalText: "<scribe>", replaceText: /<scribe>/g, value: filteredResults?.[0]?.isscribe == 0 ? "Yes" : "No" ,Name:"Isscribe"},
  //   { originalText: "<venuecode>", replaceText: /<venuecode>/g, value: filteredResults?.[0]?.referenceid,Name:"Venue Code" },
  // ];

  // const modifyWordFile = async () => {
  //   dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });

  //   // urlToFile(uploadfile, "downloaded_file.docx").then(file => {
  //   // });

  //   // if (!uploadfile || uploadfile.type !== "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
  //     // setMessage("Please upload a valid Word (.docx) file.");
  //   //   return;
  //   // }

  //   try {
  //     let fileBlob;

  //     // Check if uploadfile is a URL (string)
  //     if (typeof uploadfile === "string") {
  //       // Fetch the file from the URL
  //       const response = await fetch(uploadfile);
  //       if (!response.ok) {
  //         throw new Error("Failed to fetch the file from the URL.");
  //       }
  //       fileBlob = await response.blob(); // Convert the response to a Blob
  //     } else if (uploadfile instanceof Blob || uploadfile instanceof File) {
  //       // If uploadfile is already a Blob or File, use it directly
  //       fileBlob = uploadfile;
  //     } else {
  //       throw new Error(
  //         "Invalid uploadfile type. Expected a URL, Blob, or File."
  //       );
  //     }

  //     // Now you can safely call arrayBuffer() on the Blob
  //     const arrayBuffer = await fileBlob.arrayBuffer();
  //     const zip = await JSZip.loadAsync(arrayBuffer);
  //     // Once we have the arrayBuffer, we can use it with JSZip
  //     // const arrayBuffer = await uploadfile.arrayBuffer();
  //     // const zip = await JSZip.loadAsync(arrayBuffer);
  //     // const arrayBuffer = await uploadfile.arrayBuffer();
  //     // const zip = await JSZip.loadAsync(arrayBuffer);

  //     const documentXml = await zip.file("word/document.xml").async("string");

  //     const parser = new DOMParser();
  //     const xmlDoc = parser.parseFromString(documentXml, "application/xml");
  //     let hasImagePlaceholder = false;
  //     let hasSignImagePlaceholder = false;
  //     const textNodes = Array.from(xmlDoc.getElementsByTagName("w:t"));
  //     let replacedWords = [];
  //     textNodes.forEach((node) => {
  //       let originalText = node.textContent;

  //       placeholders.forEach(({ replaceText, value }) => {
  //         if (originalText.includes(replaceText.source)) {
  //           replacedWords.push(originalText);
  //           originalText = originalText.replace(replaceText, value);
  //         }
  //       });

  //       if (originalText.includes("<image>")) {
  //         originalText = "";
  //         hasImagePlaceholder = true;
  //       }

  //       if (originalText.includes("<signature>")) {
  //         originalText = originalText.replace(/<signature>/g, "signature");
  //         hasSignImagePlaceholder = true;
  //       }

  //       node.textContent = originalText;
  //     });

  //     if (hasImagePlaceholder) {
  //       // const imageUrl = "https://storage.googleapis.com/mh-cet-registration/uploads/12196/profile/12196_photo.jpeg_20250124_124326"; // Replace with your image URL
  //       // const imageUrl = "https://picsum.photos/536/354"; // Replace with your image URL
  //       const imageUrl = filteredResults[0]?.fileurl; // Replace with your image URL
  //       const imageResponse = await fetch(imageUrl);
  //       // const imageResponse = await fetch(imageUrl, { mode: "cors" });

  //       if (!imageResponse.ok) {
  //         throw new Error("Failed to fetch the image.");
  //       }
  //       const imageBlob = await imageResponse.blob();

  //       // Add the image to the Word package with a unique filename
  //       zip.file("word/media/image1.png", imageBlob);

  //       const relsXml = await zip
  //         .file("word/_rels/document.xml.rels")
  //         .async("string");
  //       const relsDoc = parser.parseFromString(relsXml, "application/xml");
  //       const relationships = relsDoc.getElementsByTagName("Relationships")[0];

  //       const newRel = relsDoc.createElement("Relationship");
  //       newRel.setAttribute("Id", "rId100"); // Unique relationship ID for this image
  //       newRel.setAttribute(
  //         "Type",
  //         "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image"
  //       );
  //       newRel.setAttribute("Target", "media/image1.png");
  //       relationships.appendChild(newRel);

  //       const serializer = new XMLSerializer();
  //       const updatedRelsXml = serializer.serializeToString(relsDoc);
  //       zip.file("word/_rels/document.xml.rels", updatedRelsXml);

  //       const drawingXml = `
  //         <w:r>
  //           <w:drawing>
  //             <wp:inline>
  //               <wp:extent cx="1905000" cy="1905000"/>
  //               <wp:docPr id="1" name="Picture 1"/>
  //               <a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">
  //                 <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">
  //                   <pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture">
  //                     <pic:nvPicPr>
  //                       <pic:cNvPr id="0" name="Picture 1"/>
  //                       <pic:cNvPicPr/>
  //                     </pic:nvPicPr>
  //                     <pic:blipFill>
  //                       <a:blip r:embed="rId100"/>
  //                       <a:stretch>
  //                         <a:fillRect/>
  //                       </a:stretch>
  //                     </pic:blipFill>
  //                     <pic:spPr>
  //                       <a:xfrm>
  //                         <a:off x="0" y="0"/>
  //                         <a:ext cx="1905000" cy="1905000"/>
  //                       </a:xfrm>
  //                       <a:prstGeom prst="rect">
  //                         <a:avLst/>
  //                       </a:prstGeom>
  //                     </pic:spPr>
  //                   </pic:pic>
  //                 </a:graphicData>
  //               </a:graphic>
  //             </wp:inline>
  //           </w:drawing>
  //         </w:r>
  //       `;
  //       const parent = textNodes.find(
  //         (node) => node.textContent === ""
  //       ).parentNode;
  //       parent.innerHTML = drawingXml;
  //     }

  //     if (hasSignImagePlaceholder) {
  //       const signImageUrl = filteredResults[1]?.fileurl;
  //       const signImageResponse = await fetch(signImageUrl);
  //       if (!signImageResponse.ok) {
  //         throw new Error("Failed to fetch the signature image.");
  //       }
  //       const signImageBlob = await signImageResponse.blob();

  //       // Add the signature image with a unique filename
  //       zip.file("word/media/signature.png", signImageBlob);

  //       const relsXml = await zip
  //         .file("word/_rels/document.xml.rels")
  //         .async("string");
  //       const relsDoc = parser.parseFromString(relsXml, "application/xml");
  //       const relationships = relsDoc.getElementsByTagName("Relationships")[0];

  //       const newRel = relsDoc.createElement("Relationship");
  //       newRel.setAttribute("Id", "rId101"); // Unique relationship ID for the signature image
  //       newRel.setAttribute(
  //         "Type",
  //         "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image"
  //       );
  //       newRel.setAttribute("Target", "media/signature.png");
  //       relationships.appendChild(newRel);

  //       const serializer = new XMLSerializer();
  //       const updatedRelsXml = serializer.serializeToString(relsDoc);
  //       zip.file("word/_rels/document.xml.rels", updatedRelsXml);

  //       const signatureDrawingXml = `
  //         <w:r>
  //           <w:drawing>
  //             <wp:inline>
  //               <wp:extent cx="1905000" cy="1905000"/>
  //               <wp:docPr id="2" name="Signature"/>
  //               <a:graphic xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main">
  //                 <a:graphicData uri="http://schemas.openxmlformats.org/drawingml/2006/picture">
  //                   <pic:pic xmlns:pic="http://schemas.openxmlformats.org/drawingml/2006/picture">
  //                     <pic:nvPicPr>
  //                       <pic:cNvPr id="0" name="Signature"/>
  //                       <pic:cNvPicPr/>
  //                     </pic:nvPicPr>
  //                     <pic:blipFill>
  //                       <a:blip r:embed="rId101"/>
  //                       <a:stretch>
  //                         <a:fillRect/>
  //                       </a:stretch>
  //                     </pic:blipFill>
  //                     <pic:spPr>
  //                       <a:xfrm>
  //                         <a:off x="0" y="0"/>
  //                         <a:ext cx="1905000" cy="1905000"/>
  //                       </a:xfrm>
  //                       <a:prstGeom prst="rect">
  //                         <a:avLst/>
  //                       </a:prstGeom>
  //                     </pic:spPr>
  //                   </pic:pic>
  //                 </a:graphicData>
  //               </a:graphic>
  //             </wp:inline>
  //           </w:drawing>
  //         </w:r>
  //       `;
  //       const parent = textNodes.find(
  //         (node) => node.textContent === "signature"
  //       ).parentNode;
  //       parent.innerHTML = signatureDrawingXml;
  //     }

  //     if (replacedWords.length === 0) {
  //       setMessage("No Metadata matches.");
  //       dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
  //       return;
  //     }

  //     const serializer = new XMLSerializer();
  //     const modifiedXml = serializer.serializeToString(xmlDoc);
  //     zip.file("word/document.xml", modifiedXml);

  //     const modifiedFileBlob = await zip.generateAsync({ type: "blob" });
  //     // const blob = new Blob([modifiedFile], { type: file.type });
  //     // convertDocxToPdfBlob(blob)
  //     const modifiedFile = new File([modifiedFileBlob], "Modified.docx", {
  //       type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //     });

  //     uploadFile(modifiedFile);

  //     setModifiedFileUrl(URL.createObjectURL(modifiedFileBlob));
  //     // const link = document.createElement("a");
  //     // link.href = URL.createObjectURL(modifiedFileBlob);
  //     // link.download = "Modified.docx";
  //     // link.click();

  //     // let officeUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(URL.createObjectURL(blob))}`
  //     // const googleDocsViewer = `https://docs.google.com/viewer?url=${encodeURIComponent(URL.createObjectURL(blob))}`;

  //     //  window.open(officeUrl,"_blank");

  //     setReplacements(replacedWords);
  //   } catch (error) {
  //     console.error("Error modifying Word file:", error);
  //     setMessage("Error modifying the Word file. Please try again.");
  //     dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });

  //   }
  // };

  const {
    driveList,
    stateList,
    districtList,
    graduationBranchList,
    awardedClassList,
    examLanguageList,
    pgBranchList,
    pgawardedClassList,
    mockBundleDetails
  } = useSelector((state) => state.masterFormsReducer);
  const { courseList } = useSelector((state) => state.masterReducer);
  const { courseCategoryList } = useSelector(
    (state) => state.masterFormsReducer
  );
const { mockDetails } = useSelector(state => state.courseReducer);





  const { eligibilityCriteria } = useSelector(
    (state) => state.eligibilityCriteriaReducer
  );

  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
  const [modelOpen, setModelOpen] = useState({
    show: false,
    type: "",
  });
  const [documentError, setDocumentError] = useState({
    error: false,
    message: "",
  });
  const [Document, setDocument] = useState({
    name: "",
    file: null,
  });

  const [isAdmitcardPublished, setIsAdmitcardPublished] = useState(0);
  const [isScorecardPublished, setIsScorecardPublished] = useState(0);


  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    trigger,
    control,
    setError,
    resetField,
    formState: { errors },
  } = useForm({
  defaultValues: {
    com_bundleid: "",
    com_maxvalue: "",
    com_gst_percent: "",
    com_amount: "",
    com_pack_selection: "",
    opt_bundleid:"",
    opt_maxvalue:"",
    opt_gst_percent:"",
    opt_amount:"",
    opt_pack_selection:"",
    psych_bundleid:"",
    psych_maxvalue:"",
    psych_gst_percent:"",
    psych_amount:"",
    psych_pack_selection:"",
  }
});;
  useEffect(() => {
    dispatch({ type: masterFormsActions.GET_DRIVE });
    dispatch({ type: masterFormsActions.GET_STATE });
    dispatch({ type: masterFormsActions.GET_DISTRICT });
    dispatch({ type: masterFormsActions.GET_COURSECATEGORY });
    dispatch({ type: masterFormsActions.GET_GRADUATION_BRANCH });
    dispatch({ type: masterFormsActions.GET_POST_GRADUATION_BRANCH });
    dispatch({ type: masterFormsActions.GET_AWARDED_CLASS });
    dispatch({ type: masterFormsActions.GET_PG_AWARDED_CLASS });
    dispatch({ type: masterFormsActions.GET_EXAM_LANGUAGE });
    dispatch({ type: eligibilityCriteriaActions.GET_ELIGIBILITY_CRITERIA });
    dispatch({ type: masterFormsActions.GET_MOCK_BUNDLE})

    if (location.search === "?page=updatecourse") {
      dispatch({
        type: masterActions.GET_COURSE_LIST,
      });
    }
  }, []);
  useEffect(() => {
    let states = watch("preferencestateid");
    if (states.length > 0) {
      let filtered = districtList?.all?.filter((obj) =>
        states?.map((id) => parseInt(id)).includes(parseInt(obj.stateid))
      );
      dispatch({
        type: masterFormsActions.SET_DISTRICT,
        payload: { ...districtList, filtered: filtered },
      });
    } else {
      dispatch({
        type: masterFormsActions.SET_DISTRICT,
        payload: { ...districtList, filtered: [] },
      });
    }
  }, [watch("preferencestateid")]);
  useEffect(() => {
    if (id) {
      let { prerequisite, ...course } = courseList?.all?.find((obj) => obj.courseid === id) || {};
      // let { regenddate, regstartdate, ...course } = fileterd
      course["regstartdate"] = dayjs(course.regstartdate);
      course["regenddate"] = dayjs(course.regenddate);
      course["latefeestartdate"] = dayjs(course.latefeestartdate);
      course["latefeeenddate"] = dayjs(course.latefeeenddate);
      course["editingstartdate"] = dayjs(course.editingstartdate);
      course["editingenddate"] = dayjs(course.editingenddate);
      course["editingextrastartdate"] = dayjs(course.editingextrastartdate);
      course["editingextraenddate"] = dayjs(course.editingextraenddate);
      course["coolingstartdate"] = dayjs(course.coolingstartdate);
      course["coolingenddate"] = dayjs(course.coolingenddate);
      course["admitcardstartdate"] = dayjs(course.admitcardstartdate);
      course["admitcardenddate"] = dayjs(course.admitcardenddate);
      course["scorecardstartdate"] = dayjs(course.scorecardstartdate);
      course["scorecardenddate"] = dayjs(course.scorecardenddate);
      course["objectiontracstartdate"] = dayjs(course.objectiontracstartdate);
      course["objectiontracenddate"] = dayjs(course.objectiontracenddate);

      if (course?.preferencestateid?.length > 0) {
        let filtered = districtList?.all?.filter((obj) =>
          course?.preferencestateid
            ?.map((id) => parseInt(id))
            .includes(parseInt(obj.stateid))
        );
        dispatch({
          type: masterFormsActions.SET_DISTRICT,
          payload: { ...districtList, filtered: filtered },
        });
      } else {
        dispatch({
          type: masterFormsActions.SET_DISTRICT,
          payload: { ...districtList, filtered: [] },
        });
      }

      course["brochurelocation"]?.trim() !== "" &&
        setDocument({
          name: course["brochurelocation"],
          file: null,
        });
      setPreRequisiteContent(prerequisite);
      for (let key in course) {
        setValue(key, course[key]);
      }
      setValue(
        "templatedocs",
        course?.templatedocs === "null" ? "" : course?.templatedocs
      );
      setValue(
        "scorecarddocs",
        course?.scorecarddocs === "null" ? "" : course?.scorecarddocs
      );

      setUploadedFile(course?.templatedocs);
      setScoreUploadedFile(course?.scorecarddocs);
      setFileName(course?.templatedocs?.split("/").pop());
      setScordCardFileName(course?.scorecarddocs?.split("/").pop());
      setValue(
        "qualificationnotes",
        course?.qualificationnotes === "null" ? "" : course?.qualificationnotes
      );
      setValue(
        "objectiontrackernotes",
        course?.objectiontrackernotes === "null"
          ? ""
          : course?.objectiontrackernotes
      );

      setValue("status", course?.status)
      setIsScorecardPublished(course?.isadmitcardpublished)
      setIsAdmitcardPublished(course?.isscorecardpublished)


    }
  }, [setValue, courseList, id]);

  const handleModelOpen = (type) => {
    setModelOpen({
      show: true,
      type: type,
    });
  };
  const [preRequisiteContent, setPreRequisiteContent] = useState("");

  const [showPreRequisite, setShowPreRequisite] = useState({
    show: false,
    data: null,
  });
  const resetForm = () => {
    setValue("coursedriveid", "");
    setValue("coursecategoryid", "");
    setDocument({ name: "", file: null });
    setFile(null);
    reset({
      coursedriveid: "", // replace with default values for all fields
      coursecategoryid: "",
      coursename: "",
      coursecode: "",
      regstartdate: null, // or the default value for date pickers
      regenddate: null,
      admitcardstartdate: null,
      admitcardenddate: null,
      scorecardstartdate: null,
      scorecardenddate: null,
      objectiontracstartdate: null,
      objectiontracenddate: null, // or the default value for date pickers
      // informationbrochure: "",
      status: true, // default value for switches or checkboxes
      // Add other fields as needed
    });
  };
  const handleClose = () => {
    setShowPreRequisite({ show: false, data: null });
  };

  const handlePreRequisite = () => {
    setShowPreRequisite({ show: true, data: null });
  };

  const CustomSwitch = styled(Switch)(({ theme }) => ({
    padding: 8,
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      "&::before, &::after": {
        content: '""',
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: 16,
        height: 16,
      },
      "&::before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main)
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 12,
      },
      "&::after": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main)
        )}" d="M19,13H5V11H19V13Z" /></svg>')`,
        right: 12,
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "none",
      width: 16,
      height: 16,
      margin: 2,
    },
  }));

  const handleUpload = (e) => {
    const file = e.target.files || e.dataTransfer.files;
    // Update form state using React Hook Form methods
    setValue("document", file[0]);
    setDocument({
      name: file[0].name,
      file: file[0],
    });
    setDocumentError({ error: false, message: "" });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy"; // Show the copy cursor when dragging
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleUpload(e);
  };

  const handleAddDrive = () => {
    let value = getValues("name");
    if (value.trim() === "") {
      trigger("name");
      return;
    }
    let data = {};
    data["drivename"] = value;
    // data['status'] = "1";
    data["userid"] = backofficeTokenDetails?.id;
    setModelOpen({
      show: false,
      type: "",
    });

    dispatch({
      type: masterFormsActions.CREATE_DRIVE,
      payload: { data: data },
    });
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: {
        show: false,
        type: null,
        method: null,
        data: null,
      },
    });
    dispatch({ type: masterFormsActions.GET_DRIVE });
  };
  const handleAddCourse = (data) => {
    const todayWithoutTime = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const regStartDate = new Date(data?.regstartdate);
    const regStartDateWithoutTime = new Date(
      regStartDate.getFullYear(),
      regStartDate.getMonth(),
      regStartDate.getDate()
    );

    if (regStartDateWithoutTime.getTime() < todayWithoutTime.getTime()) {
      setError("regstartdate", {
        type: "custom",
        message: "please select a future date",
      });
      return;
    }

    if (!isDateGreaterThanDay(data.regenddate, new Date(data?.regstartdate))) {
      setError("regenddate", {
        type: "custom",
        message: "please select a date greater than start date",
      });
      return;
    }
    if (Document?.name !== "") {
      setDocumentError({ error: false, message: "" });

      data["prerequisite"] = preRequisiteContent;
      data["userid"] = backofficeTokenDetails?.id;
      data["regstartdate"] = formatDate(data?.regstartdate);
      data["regenddate"] = formatDate(data.regenddate);
      data["latefeestartdate"] = formatDate(data.latefeestartdate);
      data["latefeeenddate"] = formatDate(data.latefeeenddate);
      data["editingstartdate"] = formatDate(data.editingstartdate);
      data["editingenddate"] = formatDate(data.editingenddate);
      data["editingextrastartdate"] = formatDate(data.editingextrastartdate);
      data["editingextraenddate"] = formatDate(data.editingextraenddate);
      data["coolingstartdate"] = formatDate(data.coolingstartdate);
      data["coolingenddate"] = formatDate(data.coolingenddate);
      data["admitcardstartdate"] = formatDate(data.admitcardstartdate);
      data["admitcardenddate"] = formatDate(data.admitcardenddate);
      data["scorecardstartdate"] = formatDate(data.scorecardstartdate);
      data["scorecardenddate"] = formatDate(data.scorecardenddate);
      data["objectiontracstartdate"] = formatDate(data.objectiontracstartdate);
      data["objectiontracenddate"] = formatDate(data.objectiontracenddate);
      data["candidateresponse"] = data.candidateresponse;
      data["paidcourse"] = data.paidcourse;
      data["isadmitcardpublished"] = isAdmitcardPublished;
      data["isscorecardpublished"] = isScorecardPublished;


      // data["objectiontrackgeneralamount"] = parseInt(
      //   data.objectiontrackgeneralamount
      // );
      // data["objectiontracknongeneralamount"] = parseInt(
      //   data.objectiontracknongeneralamount
      // );
      data["templatedocs"] = file == null ? null : file;
      data["scorecarddocs"] = scorecard == null ? null : scorecard;
      data["coursecategoryid"] = parseInt(data.coursecategoryid);
      data["coursedriveid"] = parseInt(data.coursedriveid);
      data["document"] = Document;

      dispatch({
        type: masterActions.CREATE_COURSE,
        payload: { data: data, navigate: navigate, resetForm: resetForm },
      });
    } else {
      setDocumentError({ error: true, message: "Please upload Document" });
    }
  };
  const handleUpdateCourse = (data) => {
    const todayWithoutTime = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const regStartDate = new Date(data?.regstartdate);
    const regStartDateWithoutTime = new Date(
      regStartDate.getFullYear(),
      regStartDate.getMonth(),
      regStartDate.getDate()
    );

    // if (regStartDateWithoutTime.getTime() < todayWithoutTime.getTime()) {
    //   setError("regstartdate", {
    //     type: "custom",
    //     message: "please select a future date",
    //   });
    //   return;
    // }

    // if (!isDateGreaterThanDay(data?.regenddate, new Date(data?.regstartdate))) {
    //   setError("regenddate", {
    //     type: "custom",
    //     message: "please select a date greater than start date",
    //   });
    //   return;
    // }
    if (Document) {
      setDocumentError({ error: false, message: "" });
      data["prerequisite"] = preRequisiteContent;
      data["userid"] = backofficeTokenDetails?.id;
      data["regstartdate"] = formatDate(data?.regstartdate);
      data["regenddate"] = formatDate(data.regenddate);
      data["latefeestartdate"] = formatDate(data.latefeestartdate);
      data["latefeeenddate"] = formatDate(data.latefeeenddate);
      data["editingstartdate"] = formatDate(data.editingstartdate);
      data["editingenddate"] = formatDate(data.editingenddate);
      data["editingextrastartdate"] = formatDate(data.editingextrastartdate);
      data["editingextraenddate"] = formatDate(data.editingextraenddate);
      data["coolingstartdate"] = formatDate(data.coolingstartdate);
      data["coolingenddate"] = formatDate(data.coolingenddate);
      data["admitcardstartdate"] = formatDate(data.admitcardstartdate);
      data["admitcardenddate"] = formatDate(data.admitcardenddate);
      data["scorecardstartdate"] = formatDate(data.scorecardstartdate);
      data["scorecardenddate"] = formatDate(data.scorecardenddate);
      data["objectiontracstartdate"] = formatDate(data.objectiontracstartdate);
      data["objectiontracenddate"] = formatDate(data.objectiontracenddate);
      data["coursecategoryid"] = parseInt(data.coursecategoryid);
      data["coursedriveid"] = parseInt(data.coursedriveid);
      data["document"] = Document;
      data["objectiontrackgeneralamount"] = parseInt(
        data.objectiontrackgeneralamount
      );
      data["objectiontracknongeneralamount"] = parseInt(
        data.objectiontracknongeneralamount
      );

      data["candidateresponse"] = data.candidateresponse
        ? data.candidateresponse
        : "";
      data["paidcourse"] = data.paidcourse
        ? data.paidcourse
        : "";
      data["templatedocs"] = file;
      data["scorecarddocs"] = scorecard;
      data["docsurl"] = typeof uploadfile === "string" ? uploadfile : null;
      data["scorecardUrl"] =
        typeof ScoreUploadedFile === "string" ? ScoreUploadedFile : null;
      data["isadmitcardpublished"] = isAdmitcardPublished;
      data["isscorecardpublished"] = isScorecardPublished;


      dispatch({
        type: masterActions.UPDATE_COURSE,
        payload: { data: data, navigate: navigate, resetForm: resetForm },
      });
    } else {
      setDocumentError({ error: true, message: "Please upload Document" });
    }
  };
  function isDateGreaterThanDay(dateString, today) {
    const dateToCompare = new Date(dateString);

    return dateToCompare >= today;
  }

  const formatDate = (date) => {
    // Assuming date is a Date object or ISO string, convert to desired format
    const formattedDate = new Date(date)
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .replace(/\//g, "-")
      .split("-")
      .reverse()
      .join("-");

    return date && formattedDate !== "Invalid Date" ? formattedDate : ""; // returns something like '01-07-2024'
  };
  const handleCloseDocument = () => {
    setDocument({
      name: "",
      file: null,
    });
  };


  useEffect(() => {
    if (isAdmitcardPublished === 1) {
      handleSubmit(
        location.search !== "?page=updatecourse"
          ? handleAddCourse
          : handleUpdateCourse
      )();
    }
  }, [isAdmitcardPublished]);

  const handlePublishAdmitCard = () => {
    setIsAdmitcardPublished(1);
    dispatch({
      type: commonActions.SET_ALERT,
      payload: {
        status: "success",
        show: true,
        message: "Admitcard published successfuly",
      },
    });
    if (isAdmitcardPublished === 1) {
      handleSubmit(
        location.search !== "?page=updatecourse"
          ? handleAddCourse
          : handleUpdateCourse
      )()
    }
    setTimeout(function () {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "success",
          show: false,
          message: null,
        },
      });
    }, 1000);
  };
  useEffect(() => {
    if (isScorecardPublished === 1) {
      handleSubmit(
        location.search !== "?page=updatecourse"
          ? handleAddCourse
          : handleUpdateCourse
      )();
    }
  }, [isScorecardPublished]);

  const handlePublishScorecard = () => {
    setIsScorecardPublished(1);
    dispatch({
      type: commonActions.SET_ALERT,
      payload: {
        status: "success",
        show: true,
        message: "Scorecard published successfuly",
      },
    });
    if (isScorecardPublished === 1) {
      handleSubmit(
        location.search !== "?page=updatecourse"
          ? handleAddCourse
          : handleUpdateCourse
      )
    }
    setTimeout(function () {
      dispatch({
        type: commonActions.SET_ALERT,
        payload: {
          status: "success",
          show: false,
          message: null,
        },
      });
    }, 1000);
  };

  useEffect(() => {
    if (id && mockDetails?.length > 0) {
      const row = mockDetails[0];

      setValue("com_bundleid", row?.com_bundleid?.toString() ?? "");
      setValue("com_maxvalue", row?.com_maxvalue ?? "");
      setValue("com_gst_percent", row?.com_gst_percent ?? "");
      setValue("com_amount", row?.com_amount ?? "");
      setValue("com_pack_selection", row?.com_pack_selection ?? "");

      setValue("opt_bundleid", row?.opt_bundleid?.toString() ?? "");
      setValue("opt_maxvalue", row?.opt_maxvalue ?? "");
      setValue("opt_gst_percent", row?.opt_gst_percent ?? "");
      setValue("opt_amount", row?.opt_amount ?? "");
      setValue("opt_pack_selection", row?.opt_pack_selection ?? "");

      setValue("psych_bundleid", row?.psych_bundleid?.toString() ?? "");
      setValue("psych_maxvalue", row?.psych_maxvalue ?? "");
      setValue("psych_gst_percent", row?.psych_gst_percent ?? "");
      setValue("psych_amount", row?.psych_amount ?? "");
      setValue("psych_pack_selection", row?.psych_pack_selection ?? "");
    }
  }, [id, mockDetails]);




  return (
    <>
      <Typography variant="h5" mb={3}>
        Course Information
      </Typography>

      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} sm={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <FormControl error={!!errors.coursedriveid} fullWidth>
              <InputLabel htmlFor="coursedriveid">
                <span>
                  Select Course Drive
                  <span className="error" style={{ color: "red" }}>
                    *
                  </span>
                </span>
              </InputLabel>
              <Controller
                name="coursedriveid"
                control={control}
                defaultValue="" // Initial value if any
                rules={{ required: "Drive Name is required" }} // Validation rule
                helperText={errors?.coursedriveid?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
                error={!!errors.coursedriveid}
                render={({ field }) => (
                  <Select
                    {...field}
                    label={
                      <span>
                        Select Course Drive
                        <span className="error" style={{ color: "red" }}>
                          *
                        </span>
                      </span>
                    }
                    labelId="coursedriveid"
                    id="coursedriveid"
                    error={!!errors.coursedriveid}
                    helperText={errors.coursedriveid?.message}
                    size="small"
                  >
                    <MenuItem value="" disabled>
                      Select Drive Name
                    </MenuItem>
                    {driveList?.all.map((obj, i) => (
                      <MenuItem
                        key={obj.driveid.toString()}
                        value={obj.driveid.toString()}
                      >
                        {obj.drivename}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
              {/* {errors?.coursedriveid?.message} */}
            </FormControl>

            <Button
              variant="outlined"
              onClick={() => {
                dispatch({
                  type: commonActions.SET_SHOW_MODAL,
                  payload: {
                    show: true,
                    type: "drive",
                    method: "C",
                    data: null,
                  },
                });
              }}
              sx={{
                color: "black",
                borderColor: "#A3A3A3",
                padding: 1,
                minWidth: "0",
              }}
            >
              <FaPlus />
            </Button>
          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.coursedriveid?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControl error={!!errors.coursecategoryid} fullWidth>
            <InputLabel htmlFor="coursecategoryid">
              <span>
                Select Course Category
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            </InputLabel>
            <Controller
              name="coursecategoryid"
              id="demo-simple-select"
              helperText={errors?.coursecategoryid?.message}
              FormHelperTextProps={{
                style: { margin: 0 },
              }}
              error={!!errors.coursecategoryid}
              rules={{ required: "Course Category is required" }}
              control={control}
              defaultValue="" // Initial value if any
              render={({ field }) => (
                <Select
                  size="small"
                  fullWidth
                  label={
                    <span>
                      Select Course Category
                      <span className="error" style={{ color: "red" }}>
                        *
                      </span>
                    </span>
                  }
                  {...field}
                  error={!!errors.coursecategoryid}
                  helperText={errors.coursecategoryid?.message}
                  FormHelperTextProps={{
                    style: { margin: 0 },
                  }}

                // defluaultValue=""
                // placeholder="Select Course Category"
                >
                  <MenuItem key="" value="" disabled>
                    Select Course Category
                  </MenuItem>

                  {courseCategoryList &&
                    courseCategoryList.all.map((obj) => {
                      return (
                        <MenuItem
                          key={obj.coursecategoryid.toString()}
                          value={obj.coursecategoryid.toString()}
                        >
                          {obj.coursecategory}
                        </MenuItem>
                      );
                    })}
                </Select>
              )}
            />
          </FormControl>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.coursecategoryid?.message}
          </FormHelperText>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("coursename", {
              required: "Course Name is required",
            })}
            InputLabelProps={{
              shrink: !!watch("coursename"),
            }}
            error={!!errors.coursename}
            helperText={errors.coursename?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Course Name
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControl error={!!errors.coursecategoryid} fullWidth>
            <InputLabel htmlFor="coursecategoryid">
              <span>
                Select Exam Language
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            </InputLabel>
            <Controller
              name="examlanguageid"
              control={control}
              rules={{ required: "Exam Language is required" }}
              defaultValue={[]} // Initial value if any
              render={({ field }) => (
                <Select
                  size="small"
                  fullWidth
                  multiple
                  value={field.value}
                  onChange={(e) => {
                    const selectedValues = e.target.value;

                    const validValues = selectedValues.filter(
                      (val) => val !== null && val !== undefined
                    );

                    const uniqueValues = Array.from(
                      new Set(validValues.map((val) => val?.toString()))
                    );

                    field.onChange(uniqueValues);
                  }}
                  label={
                    <span>
                      Select Exam Language
                      <span className="error" style={{ color: "red" }}>
                        *
                      </span>
                    </span>
                  }
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value) => {
                        const selectedLanguage = examLanguageList?.all?.find(
                          (lang) =>
                            parseInt(lang.examlanguageid) === parseInt(value)
                        );
                        return (
                          <Chip
                            key={value}
                            label={selectedLanguage?.languagename || "Unknown"}
                          />
                        );
                      })}
                    </Box>
                  )}
                  error={!!errors.examlanguageid}
                >
                  <MenuItem key="" value="" disabled>
                    Select Exam Language
                  </MenuItem>

                  {examLanguageList &&
                    examLanguageList.all.map((obj) => (
                      <MenuItem
                        key={obj.examlanguageid?.toString()}
                        value={obj.examlanguageid?.toString()}
                      >
                        {obj.languagename}
                      </MenuItem>
                    ))}
                </Select>
              )}
            />
          </FormControl>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.examlanguageid?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            {...register("coursecode", {
              required: "Course Code is required",
              validate: (value) => {
                return value
                  ? /^\d+$/.test(value) || "Course Code must be numeric"
                  : true;
              },
            })}
            InputLabelProps={{
              shrink: !!watch("coursecode"),
            }}
            error={!!errors.coursecode}
            helperText={errors.coursecode?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Course Code
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
            onChange={(e) => {
              const value = e.target.value;
              setValue("coursecode", value);
              trigger("coursecode");
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormGroup row>
            <Controller
              name="isotbs"
              control={control}
              // defaultValue={true}

              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      onChange={(e) => {
                        setValue("isotbs", e.target.checked);
                        setValue("preferencedistrictid", []);
                        setValue("preferencestateid", []);
                      }}
                      checked={watch("isotbs") ?? false}
                    />
                  }
                  label="IS OTBS"
                />
              )}
            />

            <Controller
              name="ispcmb"
              control={control}
              // defaultValue={false}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      onChange={(e) => {
                        setValue("ispcmb", e.target.checked);
                        // setValue("preferencedistrictid",[])
                        // setValue("preferencestateid",[])
                      }}
                      checked={watch("ispcmb") ?? false}
                    />
                  }
                  label="IS PCMB"
                />
              )}
            />

            <Controller
              name="isewsenabled"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      onChange={(e) => {
                        setValue("isewsenabled", e.target.checked);
                      }}
                      checked={watch("isewsenabled") ?? false}
                    />
                  }
                  label="IS EWS"
                />
              )}
            />
          </FormGroup>
        </Grid>
        <Grid item md={6} xs={12}>
          <TextField
            multiline
            name="qualificationnotes"
            {...register("qualificationnotes")}
            label="Qualification Notes"
            placeholder="Enter Qualification Notes"
            fullWidth
            rows={6}
            error={!!errors.coursecategoryid}
            helperText={errors.coursecategoryid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            InputLabelProps={{
              shrink: !!watch("qualificationnotes"),
            }}
          />
        </Grid>
      </Grid>

      <Typography variant="h5" mb={3}>
        Qualification Information
      </Typography>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} sm={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <FormControl error={!!errors.graduationbranchid} fullWidth>
              <InputLabel htmlFor="graduationbranchid">
                <span>Select Graduation Branches</span>
              </InputLabel>
              <Controller
                name="graduationbranchid"
                control={control}
                defaultValue={[]} // Initial value if any
                render={({ field }) => (
                  <Select
                    {...field}
                    multiple
                    value={field.value}
                    onChange={(e) => {
                      const selectedValues = e.target.value;

                      const validValues = selectedValues.filter(
                        (val) => val !== null && val !== undefined
                      );

                      const uniqueValues = Array.from(
                        new Set(validValues.map((val) => val?.toString()))
                      );

                      field.onChange(uniqueValues);
                    }}
                    renderValue={(selected) => {
                      if (!selected ||
                        selected.length === 0 ||
                        (selected.length === 1 && selected[0] === null)){
                         return <em>Select Graduation Branch</em>;
                        }
                      return (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => {
                          const selectedBranch =
                            graduationBranchList?.all?.find(
                              (lang) =>
                                parseInt(lang.graduationbranchid) ===
                                parseInt(value)
                            );
                          if (!selectedBranch?.graduationbranch) return null;
  
                          return (
                            <Chip
                              key={value}
                              label={
                                selectedBranch?.graduationbranch
                              }
                            />
                          );
                        })}
                      </Box>
                    )}
                    }
                      
                    label={<span>Select Graduation Branches</span>}
                    labelId="graduationbranchid"
                    id="graduationbranchid"
                    error={!!errors.graduationbranchid}
                    size="small"
                  >
                    <MenuItem value="" disabled>
                      Select Graduation Branches
                    </MenuItem>
                    {graduationBranchList?.all.map((obj) => (
                      <MenuItem
                        key={obj.graduationbranchid?.toString()}
                        value={obj.graduationbranchid?.toString()}
                      >
                        {obj.graduationbranch}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.graduationbranchid?.message}
          </FormHelperText>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <FormControl error={!!errors.awardedclassid} fullWidth>
              <InputLabel htmlFor="awardedclassid">
                <span>Select Awarded Class</span>
              </InputLabel>
              <Controller
                name="awardedclassid"
                control={control}
                defaultValue={[]} // Initial value if any
                render={({ field }) => (
                  <Select
                    {...field}
                    multiple
                    placeholder="Select Awarded Class"
                    value={field.value}
                    onChange={(e) => {
                      const selectedValues = e.target.value;

                      const validValues = selectedValues.filter(
                        (val) => val !== null && val !== undefined
                      );

                      const uniqueValues = Array.from(
                        new Set(validValues.map((val) => val?.toString()))
                      );

                      field.onChange(uniqueValues);
                    }}
                    renderValue={(selected) => {
                      if (!selected ||
                        selected.length === 0 ||
                        (selected.length === 1 && selected[0] === null)
                      ) {
                        return <em>Select Awarded Class</em>;
                      }

                      return (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {selected.map((value) => {
                            const selectedClass = awardedClassList?.all?.find(
                              (lang) => parseInt(lang.awardedclassid) === parseInt(value)
                            );

                            if (!selectedClass?.awardedclass) return null;

                            return (
                              <Chip
                                key={value}
                                label={selectedClass.awardedclass}
                              />
                            );
                          })}
                        </Box>
                      );
                    }}
                    label={<span>Select Awarded Class</span>}
                    labelId="awardedclassid"
                    id="awardedclassid"
                    error={!!errors.awardedclassid}
                    size="small"
                  >
                    <MenuItem value="" disabled>
                      Select Awarded Class
                    </MenuItem>
                    {awardedClassList?.all.map((obj) => (
                      <MenuItem
                        key={obj.awardedclassid?.toString()}
                        value={obj.awardedclassid?.toString()}
                      >
                        {obj.awardedclass}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.awardedclassid?.message}
          </FormHelperText>
        </Grid>

                      <Grid item xs={12} sm={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <FormControl error={!!errors.pgbranchid} fullWidth>
              <InputLabel htmlFor="pgbranchid">
                <span>Select Post Graduation Branches</span>
              </InputLabel>
              <Controller
                name="pgbranchid"
                control={control}
                defaultValue={[]} // Initial value if any
                render={({ field }) => (
                  <Select
                    {...field}
                    multiple
                    value={field.value}
                    onChange={(e) => {
                      const selectedValues = e.target.value;

                      const validValues = selectedValues.filter(
                        (val) => val !== null && val !== undefined
                      );

                      const uniqueValues = Array.from(
                        new Set(validValues.map((val) => val?.toString()))
                      );

                      field.onChange(uniqueValues);
                    }}
                    renderValue={(selected) => {
                      if (!selected ||
                        selected.length === 0 ||
                        (selected.length === 1 && selected[0] === null)){
                         return <em>Select Post Graduation Branches</em>;
                        }
                      return (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => {
                          const selectedBranch =
                            pgBranchList?.all?.find(
                              (lang) =>
                                parseInt(lang.pgbranchid) ===
                                parseInt(value)
                            );
                          if (!selectedBranch?.pgbranch) return null;
  
                          return (
                            <Chip
                              key={value}
                              label={
                                selectedBranch?.pgbranch
                              }
                            />
                          );
                        })}
                      </Box>
                    )}
                    }
                      
                    label={<span>Select Post Graduation Branches</span>}
                    labelId="pgbranchid"
                    id="pgbranchid"
                    error={!!errors.pgbranchid}
                    size="small"
                  >
                    <MenuItem value="" disabled>
                      Select Post Graduation Branches
                    </MenuItem>
                    {pgBranchList?.all.map((obj) => (
                      <MenuItem
                        key={obj.pgbranchid?.toString()}
                        value={obj.pgbranchid?.toString()}
                      >
                        {obj.pgbranch}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.pgbranchid?.message}
          </FormHelperText>
        </Grid>

                <Grid item xs={12} sm={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <FormControl error={!!errors.pgawardedclassid} fullWidth>
              <InputLabel htmlFor="pgawardedclassid">
                <span>Select Post graduation Awarded Class</span>
              </InputLabel>
              <Controller
                name="pgawardedclassid"
                control={control}
                defaultValue={[]} // Initial value if any
                render={({ field }) => (
                  <Select
                    {...field}
                    multiple
                    placeholder="Select Post graduation Awarded Class"
                    value={field.value}
                    onChange={(e) => {
                      const selectedValues = e.target.value;

                      const validValues = selectedValues.filter(
                        (val) => val !== null && val !== undefined
                      );

                      const uniqueValues = Array.from(
                        new Set(validValues.map((val) => val?.toString()))
                      );

                      field.onChange(uniqueValues);
                    }}
                    renderValue={(selected) => {
                      if (!selected ||
                        selected.length === 0 ||
                        (selected.length === 1 && selected[0] === null)
                      ) {
                        return <em>Select Post graduation Awarded Class</em>;
                      }

                      return (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {selected.map((value) => {
                            const selectedClass = pgawardedClassList?.all?.find(
                              (lang) => parseInt(lang.awardedclassid) === parseInt(value)
                            );

                            if (!selectedClass?.awardedclassid) return null;

                            return (
                              <Chip
                                key={value}
                                label={selectedClass.awardedclass}
                              />
                            );
                          })}
                        </Box>
                      );
                    }}
                    label={<span>Select Post graduation Awarded Class</span>}
                    labelId="pgawardedclassid"
                    id="pgawardedclassid"
                    error={!!errors.pgawardedclassid}
                    size="small"
                  >
                    <MenuItem value="" disabled>
                      Select Post graduation Awarded Class
                    </MenuItem>
                    {pgawardedClassList?.all.map((obj) => (
                      <MenuItem
                        key={obj.awardedclassid?.toString()}
                        value={obj.awardedclassid?.toString()}
                      >
                        {obj.awardedclass}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.pgawardedclassid?.message}
          </FormHelperText>
        </Grid>
      </Grid>




      <Typography variant="h5" mb={3}>
        Preference Information
      </Typography>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} sm={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <FormControl error={!!errors.preferencestateid} fullWidth>
              <InputLabel htmlFor="preferencestateid">
                <span>
                  Select Preference States
                  {!watch("isotbs") && (
                    <span className="error" style={{ color: "red" }}>
                      *
                    </span>
                  )}
                </span>
              </InputLabel>
              <Controller
                name="preferencestateid"
                control={control}
                defaultValue={[]}
                rules={{
                  required: !watch("isotbs")
                    ? "Preference States is required"
                    : false,
                }}
                render={({ field }) => (
                  <Select
                    {...field}
                    multiple
                    value={field.value}
                    onChange={(e) => {
                      const selectedValues = e.target.value;
                      const validValues = selectedValues.filter(
                        (val) => val !== null && val !== undefined
                      );
                      const uniqueValues = Array.from(
                        new Set(validValues.map((val) => val?.toString()))
                      );

                      field.onChange(uniqueValues);

                      if (uniqueValues.length === 0) {
                        // Reset districts when no states are selected
                        resetField("preferencedistrictid");
                      } else {
                        // Optional: Update districts based on the selected states
                        // (Implement your logic to filter districts based on states)
                      }
                    }}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => {
                          const selectedState = stateList?.all?.find(
                            (lang) => parseInt(lang.stateid) === parseInt(value)
                          );
                          return (
                            selectedState && (
                              <Chip key={value} label={selectedState.state} />
                            )
                          );
                        })}
                      </Box>
                    )}
                    label={
                      <span>
                        Select Preference States
                        <span className="error" style={{ color: "red" }}>
                          *
                        </span>
                      </span>
                    }
                    labelId="preferencestateid"
                    id="preferencestateid"
                    error={!!errors.preferencestateid}
                    size="small"
                    disabled={watch("isotbs")}
                  >
                    <MenuItem value="" disabled>
                      Select States
                    </MenuItem>
                    {stateList?.all.map((obj) => (
                      <MenuItem
                        key={obj.stateid?.toString()}
                        value={obj.stateid?.toString()}
                      >
                        {obj.state}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
            <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
              {errors?.preferencestateid?.message}
            </FormHelperText>
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <FormControl error={!!errors.preferencedistrictid} fullWidth>
              <InputLabel htmlFor="preferencedistrictid">
                <span>
                  Select Preference Districts
                  {!watch("isotbs") && (
                    <span className="error" style={{ color: "red" }}>
                      *
                    </span>
                  )}
                </span>
              </InputLabel>
              <Controller
                name="preferencedistrictid"
                control={control}
                defaultValue={[]} // Initial value if any
                rules={{
                  required: !watch("isotbs")
                    ? "Preference Districts is required"
                    : false,
                }}
                render={({ field }) => (
                  <Select
                    {...field}
                    multiple
                    value={field.value}
                    onChange={(e) => {
                      const selectedValues = e.target.value;
                      const validValues = selectedValues.filter(
                        (val) => val !== null && val !== undefined
                      );
                      const uniqueValues = Array.from(
                        new Set(validValues.map((val) => val?.toString()))
                      );

                      if (uniqueValues.length === 0) {
                        // Reset districts when no states are selected
                        resetField("preferencedistrictid");
                      }

                      field.onChange(uniqueValues);
                    }}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => {
                          const selectedDistrict = districtList?.filtered?.find(
                            (lang) =>
                              parseInt(lang.districtid) === parseInt(value)
                          );
                          return (
                            selectedDistrict && (
                              <Chip
                                key={value}
                                label={selectedDistrict.district}
                              />
                            )
                          );
                        })}
                      </Box>
                    )}
                    label={
                      <span>
                        Select Preference Districts
                        <span className="error" style={{ color: "red" }}>
                          *
                        </span>
                      </span>
                    }
                    labelId="preferencedistrictid"
                    id="preferencedistrictid"
                    error={!!errors.preferencedistrictid}
                    size="small"
                    disabled={watch("isotbs")}
                  >
                    <MenuItem value="" disabled>
                      Select Districts
                    </MenuItem>
                    {districtList?.filtered.map((obj) => (
                      <MenuItem
                        key={obj.districtid.toString()}
                        value={obj.districtid.toString()}
                      >
                        {obj.district}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              />
            </FormControl>
            <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
              {errors?.preferencedistrictid?.message}
            </FormHelperText>
          </Box>
        </Grid>
      </Grid>

      <Typography variant="h5" mb={3}>
        Date Information
      </Typography>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={6}>
          {/* <Controller
            name="regstartdate"
            control={control}
            rules={{
              required: "Registration start date is required",
              validate: {
                validDate: (date) => {
                  const isValid =
                    date &&
                    (dayjs(date).isSame(dayjs(), "day") ||
                      dayjs(date).isAfter(dayjs(), "day"));
                  return isValid || "Date must be a today or later";
                },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Registration Start Date
                      <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span>
                    </span>
                  }
                  format="DD/MM/YYYY"
                  disablePast
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.regstartdate,
                      helperText: errors.regstartdate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          /> */}
          <Controller
            name="regstartdate"
            control={control}
            rules={{
              required: "Registration start date is required",
              validate: {
                validDate: (date) => {
                  if (location.search === "?page=updatecourse") {
                    return true;
                  }

                  const isValid =
                    date &&
                    (dayjs(date).isSame(dayjs(), "day") ||
                      dayjs(date).isAfter(dayjs(), "day"));
                  return isValid || "Date must be today or later";
                },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Registration Start Date
                      <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span>
                    </span>
                  }
                  format="DD/MM/YYYY"
                  disablePast
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.regstartdate,
                      helperText: errors.regstartdate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="regenddate"
            control={control}
            rules={{
              required: "Registration end date is required",
              validate: {
                validDate: (date) => {
                  const isValid =
                    date &&
                    (dayjs(date).isSame(dayjs(), "day") ||
                      dayjs(date).isAfter(dayjs(), "day"));
                  return isValid || "Date must be a today or later";
                },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Registration End Date
                      <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span>
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("regstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.regenddate,
                      helperText: errors.regenddate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="latefeestartdate"
            control={control}
            rules={{
              // required: "Late Fee Registration start date is required",
              // validate: {
              //   validDate: (date) => {
              //     const isValid = date && (dayjs(date).isSame(dayjs(), "day") || dayjs(date).isAfter(dayjs(), "day"));
              //     const isNotGreaterThanRegEndDate = date <= watch("regstartdate") ? "Late Fee Registration start date must be greater than registration end date." : null
              //     return isValid || isNotGreaterThanRegEndDate || "Date must be of today or later or must be greater than registration end date.";
              //   },
              // },

              validate: {
                validDateAndAfterRegStart: (date) => {
                  if (!date) return "Date is required";

                  const regEndDate = watch("regenddate");
                  const today = dayjs();

                  if (!dayjs(date).isValid()) return "Invalid date";

                  if (!(dayjs(date).isSame(today, "day") || dayjs(date).isAfter(today, "day"))) {
                    return "Date must be today or later";
                  }

                  if (regEndDate && dayjs(regEndDate).isValid()) {
                    if (!dayjs(date).isAfter(dayjs(regEndDate), "day")) {
                      return "Late Fee Registration start date must be greater than Registration End Date";
                    }
                  }

                  return true;
                },
              },



            }}

            
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Late Fee Registration Start Date
                      {/* <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span> */}
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("regstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.latefeestartdate,
                      helperText: errors.latefeestartdate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="latefeeenddate"
            control={control}
            rules={{
              // // required: "Late Fee Registration end date is required",
              validate: {
                // validDate: (date) => {
                //   const isValid =
                //     date &&
                //     (dayjs(date).isSame(dayjs(), "day") ||
                //       dayjs(date).isAfter(dayjs(), "day"));
                //   return isValid || "Date must be a today or later";
                // },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Late Fee Registration End Date
                      {/* <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span> */}
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("latefeestartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.latefeeenddate,
                      helperText: errors.latefeeenddate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="coolingstartdate"
            control={control}
            rules={{
              // // required: "Cooling period start date is required",
              validate: {
                // validDate: (date) => {
                //   const isValid =
                //     date &&
                //     (dayjs(date).isSame(dayjs(), "day") ||
                //       dayjs(date).isAfter(dayjs(), "day"));
                //   return isValid || "Date must be a today or later";
                // },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Cooling Period Start Date
                      {/* <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span> */}
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("regstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.coolingstartdate,
                      helperText: errors.coolingstartdate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="coolingenddate"
            control={control}
            rules={{
              // // required: "Cooling period end date is required",
              validate: {
                // validDate: (date) => {
                //   const isValid =
                //     date &&
                //     (dayjs(date).isSame(dayjs(), "day") ||
                //       dayjs(date).isAfter(dayjs(), "day"));
                //   return isValid || "Date must be a today or later";
                // },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Cooling Period End Date
                      {/* <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span> */}
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("coolingstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.coolingenddate,
                      helperText: errors.coolingenddate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="editingstartdate"
            control={control}
            rules={{
              // required: watch("ispcmb")
              //   ? "Editing Facility start date is required"
              //   : false,
              validate: {
                // validDate: (date) => {
                //   const isValid =
                //     date &&
                //     (dayjs(date).isSame(dayjs(), "day") ||
                //       dayjs(date).isAfter(dayjs(), "day"));
                //   return isValid || "Date must be a today or later";
                // },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Editing Facility Start Date
                      {watch("ispcmb") && (
                        <span className="error" style={{ color: "red" }}>
                          {" "}
                          *
                        </span>
                      )}
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("regstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  disabled={!watch("ispcmb")}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.editingstartdate,
                      helperText: errors.editingstartdate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="editingenddate"
            control={control}
            rules={{
              // required: watch("ispcmb")
              //   ? "Editing Facility end date is required"
              //   : false,
              validate: {
                // validDate: (date) => {
                //   const isValid =
                //     date &&
                //     (dayjs(date).isSame(dayjs(), "day") ||
                //       dayjs(date).isAfter(dayjs(), "day"));
                //   return isValid || "Date must be a today or later";
                // },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Editing Facility End Date
                      {watch("ispcmb") && (
                        <span className="error" style={{ color: "red" }}>
                          {" "}
                          *
                        </span>
                      )}
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("editingstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  disabled={!watch("ispcmb")}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.editingenddate,
                      helperText: errors.editingenddate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="editingextrastartdate"
            control={control}
            rules={{
              // // required: "Editing Facility extra fee end date is required",
              validate: {
                // validDate: (date) => {
                //   const isValid =
                //     date &&
                //     (dayjs(date).isSame(dayjs(), "day") ||
                //       dayjs(date).isAfter(dayjs(), "day"));
                //   return isValid || "Date must be a today or later";
                // },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Editing Facility Extra Fee Start Date
                      {/* <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span> */}
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("regstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.editingextrastartdate,
                      helperText: errors.editingextrastartdate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="editingextraenddate"
            control={control}
            rules={{
              // // required: "Editing Facility extra fee end date is required",
              validate: {
                // validDate: (date) => {
                //   const isValid =
                //     date &&
                //     (dayjs(date).isSame(dayjs(), "day") ||
                //       dayjs(date).isAfter(dayjs(), "day"));
                //   return isValid || "Date must be a today or later";
                // },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Editing Facility Extra Fee End Date
                      {/* <span className="error" style={{ color: "red" }}>
                        {" "}
                        *
                      </span> */}
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("editingextrastartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.editingextraenddate,
                      helperText: errors.editingextraenddate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
      </Grid>

      <Typography variant="h5" mb={3}>
        Admitcard
      </Typography>
      {/* <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={6}>
          <Controller
            name="admitcardstartdate"
            control={control}
            rules={{
              validate: {
                validDate: (date) => {
                  const isValid =
                    date &&
                    (dayjs(date).isSame(dayjs(), "day") ||
                      dayjs(date).isAfter(dayjs(), "day"));
                  return isValid || "Date must be a today or later";
                },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Admitcard Start Date

                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("regstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.admitcardstartdate,
                      helperText: errors.admitcardstartdate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="admitcardenddate"
            control={control}
            rules={{
              validate: {
                validDate: (date) => {
                  const isValid =
                    date &&
                    (dayjs(date).isSame(dayjs(), "day") ||
                      dayjs(date).isAfter(dayjs(), "day"));
                  return isValid || "Date must be a today or later";
                },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={
                    <span>
                      Admitcard End Date
 
                    </span>
                  }
                  format="DD/MM/YYYY"
                  minDate={watch("admitcardstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.admitcardenddate,
                      helperText: errors.admitcardenddate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
      </Grid> */}
      <Grid container spacing={3} mb={3}>
        {/* Admit Card Start Date */}
        <Grid item xs={12} md={6}>
          <Controller
            name="admitcardstartdate"
            control={control}
            rules={{
              validate: {
                validDate: (date) => {
                  if (location.search === "?page=updatecourse") {
                    return true;
                  }

                  const isValid =
                    date &&
                    (dayjs(date).isSame(dayjs(), "day") ||
                      dayjs(date).isAfter(dayjs(), "day"));
                  return isValid || "Date must be today or later";
                },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label="Admit Card Start Date"
                  format="DD/MM/YYYY"
                  minDate={watch("regstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.admitcardstartdate,
                      helperText: errors.admitcardstartdate?.message || "",
                      FormHelperTextProps: { style: { margin: 0 } },
                      style: { width: "100%", borderRadius: "8px" },
                    },
                    layout: { sx: { borderRadius: "58px" } },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>

        {/* Admit Card End Date */}
        <Grid item xs={12} md={6}>
          <Controller
            name="admitcardenddate"
            control={control}
            // rules={{
            //   validate: {
            //     validDate: (date) => {
            //       if (!date) return true; // Allow empty values
            //       const isValid =
            //         dayjs(date).isSame(dayjs(), "day") ||
            //         dayjs(date).isAfter(dayjs(), "day");
            //       return isValid || "Date must be today or later";
            //     },
            //   },
            // }}
            rules={{
              validate: {
                validDate: (date) => {
                  if (location.search === "?page=updatecourse") {
                    return true;
                  }

                  const isValid =
                    date &&
                    (dayjs(date).isSame(dayjs(), "day") ||
                      dayjs(date).isAfter(dayjs(), "day"));
                  return isValid || "Date must be today or later";
                },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label="Admit Card End Date"
                  format="DD/MM/YYYY"
                  minDate={watch("admitcardstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.admitcardenddate,
                      helperText: errors.admitcardenddate?.message || "",
                      FormHelperTextProps: { style: { margin: 0 } },
                      style: { width: "100%", borderRadius: "8px" },
                    },
                    layout: { sx: { borderRadius: "58px" } },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} md={6} lg={6}>
        {/* <div
          style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}
        >

             <TextField
        label={
          <span>
            Upload Admit Card
            <span className="error" style={{ color: "red" }}>
              {" "}
              *
            </span>
          </span>
        }
        type="text"
        value={fileName || "No file chosen"} // Display file name or default text
        fullWidth
        InputProps={{
          readOnly: true, // Make the text field read-only
        }}
        error={!!errors.uploadfile}
        helperText={errors.uploadfile?.message}
        FormHelperTextProps={{
          style: { margin: 0 },
        }}
      />
      <input
        type="file"
        accept=".doc, .docx"
        onChange={handleFileUpload}
        style={{ display: "none" }} // Hide the file input
        id="file-input"
      />
      <label htmlFor="file-input" style={{ cursor: "pointer", color: "#1976d2" }}>
        Choose File
      </label>
          <Button
            variant="contained"
            size="small"
            style={{
              marginLeft: "8px",
              height: "40px",
            }}
            onClick={modifyWordFile}
          >
            Preview
          </Button>
        </div> */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "5px",
            position: "relative", // Allows positioning the input button inside the TextField
          }}
        >
          <TextField
            label={
              <span>
                Upload AdmitCard Template
                {/* <span className="error" style={{ color: "red" }}>
          {" "}
          *
        </span> */}
              </span>
            }
            type="text"
            value={fileName || "No file chosen"}
            fullWidth
            InputProps={{
              readOnly: true,
              endAdornment: (
                <label
                  htmlFor="file-input"
                  style={{
                    cursor: "pointer",
                    color: "#1976d2",
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1,
                  }}
                >
                  Choose File
                </label>
              ),
            }}
            error={!!errors.uploadfile}
            helperText={errors.uploadfile?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
          />
          <input
            type="file"
            accept=".doc, .docx"
            onChange={handleFileUpload}
            style={{ display: "none" }}
            id="file-input"
          />
          <Button
            variant="contained"
            size="small"
            style={{
              marginLeft: "8px",
              height: "40px",
            }}
            onClick={() => {
              modifyWordFileCard({
                uploadfile,
                dispatch,
                ipAddress,
                filteredResults,
                setModifiedFileUrl,
                setPreview,
                setMessage,
                placeholders,
                setIsDialogOpen,
                setMetaData,
                setShowIframe,
                barcodeDataUrl,
                // candidateName: candidate?.candidatename,
              });
              setShowScoredata(false);
            }}
            disabled={!fileName || coursecandidatelist?.length == 0}
          >
            Preview
          </Button>
        </div>
      </Grid>
      <div
        style={{
          display: "flex",
          color: "red",
          fontSize: "10px",
          marginBottom: "5px",
        }}
      >
        {!showScoredata ? message : null}
      </div>
      <div style={{ display: "flex", gap: "10px" }}>
        <MauvelousPrimaryButton
          title="Publish Admitcard"
          disabled={!fileName || coursecandidatelist?.length === 0}
          handleClick={handlePublishAdmitCard}
        />

        <MauvelousPrimaryButton
          title="View Meta Data"
          handleClick={() => {
            setShowScoredata(false);
            setMetaData(true);
            setIsDialogOpen(true);
            setShowIframe(false);
          }}
        />
      </div>

      <Grid item xs={12} sm={12} md={6} lg={6} mt={2}>
        <Typography variant="h5" mb={3}>
          Scorecard
        </Typography>
        <Grid container spacing={3} mb={3}>
          <Grid item xs={12} md={6}>
            <Controller
              name="scorecardstartdate"
              control={control}
              rules={{
                validate: {
                  validDate: (date) => {
                    if (location.search === "?page=updatecourse") {
                      return true;
                    }

                    const isValid =
                      date &&
                      (dayjs(date).isSame(dayjs(), "day") ||
                        dayjs(date).isAfter(dayjs(), "day"));
                    return isValid || "Date must be today or later";
                  },
                },
              }}
              render={({ field }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    {...field}
                    label={<span>Scorecard Start Date</span>}
                    format="DD/MM/YYYY"
                    minDate={watch("regstartdate") || dayjs()}
                    onChange={(date) => field.onChange(date)}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        readOnly: true,
                        size: "small",
                        error: !!errors.scorecardstartdate,
                        helperText: errors.scorecardstartdate?.message,
                        FormHelperTextProps: {
                          style: { margin: 0 },
                        },
                        style: {
                          width: "100%",
                          borderRadius: "8px",
                        },
                      },
                      layout: {
                        sx: {
                          borderRadius: "58px",
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Controller
              name="scorecardenddate"
              control={control}
              rules={{
                validate: {
                  validDate: (date) => {
                    if (location.search === "?page=updatecourse") {
                      return true;
                    }

                    const isValid =
                      date &&
                      (dayjs(date).isSame(dayjs(), "day") ||
                        dayjs(date).isAfter(dayjs(), "day"));
                    return isValid || "Date must be today or later";
                  },
                },
              }}
              render={({ field }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    {...field}
                    label={<span>Scorecard End Date</span>}
                    format="DD/MM/YYYY"
                    minDate={watch("scorecardstartdate") || dayjs()}
                    onChange={(date) => field.onChange(date)}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        readOnly: true,
                        size: "small",
                        error: !!errors.scorecardenddate,
                        helperText: errors.scorecardenddate?.message,
                        FormHelperTextProps: {
                          style: { margin: 0 },
                        },
                        style: {
                          width: "100%",
                          borderRadius: "8px",
                        },
                      },
                      layout: {
                        sx: {
                          borderRadius: "58px",
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              )}
            />
          </Grid>
        </Grid>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "5px",
            position: "relative", // Allows positioning the input button inside the TextField
          }}
        >
          <TextField
            label={<span>Upload ScoreCard Template</span>}
            type="text"
            value={ScordCardFileName || "No file chosen"}
            fullWidth
            InputProps={{
              readOnly: true,
              endAdornment: (
                <label
                  htmlFor="score-card"
                  style={{
                    cursor: "pointer",
                    color: "#1976d2",
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 1,
                  }}
                >
                  Choose File
                </label>
              ),
            }}
            error={!!errors.ScoreUploadedFile}
            helperText={errors.ScoreUploadedFile?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
          />
          <input
            type="file"
            accept=".doc, .docx"
            onChange={handleScoreCardFileUpload}
            style={{ display: "none" }}
            id="score-card"
          />
          <Button
            variant="contained"
            size="small"
            style={{
              marginLeft: "8px",
              height: "40px",
            }}
            onClick={async () => {
              setShowScoredata(true);
              await modifyWordFileCard({
                uploadfile: ScoreUploadedFile,
                dispatch,
                ipAddress,
                filteredResults,
                setModifiedFileUrl,
                setPreview,
                setMessage,
                placeholders: placeholders1,
                setIsDialogOpen,
                setMetaData,
                setShowIframe,
                // candidateName: candidate?.candidatename,
              });
            }}
            disabled={!ScordCardFileName || coursecandidatelist?.length == 0}
          >
            Preview
          </Button>
        </div>
      </Grid>
      <div
        style={{
          display: "flex",
          color: "red",
          fontSize: "10px",
          marginBottom: "5px",
        }}
      >
        {showScoredata ? message : null}
      </div>

      <div style={{ display: "flex", gap: "10px" }}>
        <MauvelousPrimaryButton
          title="Publish ScoreCard"
          disabled={!ScordCardFileName || coursecandidatelist?.length == 0}
          handleClick={handlePublishScorecard}
        />
        <MauvelousPrimaryButton
          title="View Meta Data"
          handleClick={() => {
            setShowScoredata(true);
            setMetaData(true);
            setIsDialogOpen(true);
            setShowIframe(false);
          }}
        />
      </div>

      <Typography variant="h5" mb={3}>
        Objection Tracker
      </Typography>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={6}>
          <Controller
            name="objectiontracstartdate"
            control={control}
            rules={{
              validate: {
                validDate: (date) => {
                  if (location.search === "?page=updatecourse") {
                    return true;
                  }

                  const isValid =
                    date &&
                    (dayjs(date).isSame(dayjs(), "day") ||
                      dayjs(date).isAfter(dayjs(), "day"));
                  return isValid || "Date must be today or later";
                },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={<span>Objection Tracker Start Date</span>}
                  format="DD/MM/YYYY"
                  minDate={watch("regstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.objectiontracstartdate,
                      helperText: errors.objectiontracstartdate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controller
            name="objectiontracenddate"
            control={control}
            rules={{
              validate: {
                validDate: (date) => {
                  if (location.search === "?page=updatecourse") {
                    return true;
                  }

                  const isValid =
                    date &&
                    (dayjs(date).isSame(dayjs(), "day") ||
                      dayjs(date).isAfter(dayjs(), "day"));
                  return isValid || "Date must be today or later";
                },
              },
            }}
            render={({ field }) => (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  {...field}
                  label={<span>Objection Tracker End Date</span>}
                  format="DD/MM/YYYY"
                  minDate={watch("objectiontracstartdate") || dayjs()}
                  onChange={(date) => field.onChange(date)}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      readOnly: true,
                      size: "small",
                      error: !!errors.objectiontracenddate,
                      helperText: errors.objectiontracenddate?.message,
                      FormHelperTextProps: {
                        style: { margin: 0 },
                      },
                      style: {
                        width: "100%",
                        borderRadius: "8px",
                      },
                    },
                    layout: {
                      sx: {
                        borderRadius: "58px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            )}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("objectiontrackgeneralamount")}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("objectiontrackgeneralamount"),
            }}
            error={!!errors.objectiontrackgeneralamount}
            helperText={errors.objectiontrackgeneralamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For Objection tracker General Amount
                {/* <span className="error" style={{ color: "red" }}>
                  *
                </span> */}
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("objectiontracknongeneralamount")}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("objectiontracknongeneralamount"),
            }}
            error={!!errors.objectiontracknongeneralamount}
            helperText={errors.objectiontracknongeneralamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For Objection tracker Non General Amount
                {/* <span className="error" style={{ color: "red" }}>
                  *
                </span> */}
              </span>
            }
          />
        </Grid>
      </Grid>

      <Box
        sx={{
          width: "100%",
        }}
      >
        <Typography sx={{ fontSize: "19px" }}>
          Display Candidate response
        </Typography>
        <Box sx={{ margin: "15px" }}>
          <Grid item xs={12} md={6}>
            <Controller
              name="candidateresponse"
              control={control}
              defaultValue="0"

              render={({ field }) => (
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    {...field}
                    onChange={(e) =>
                      setValue("candidateresponse", e.target.value)
                    }
                    value={watch("candidateresponse") ?? "0"}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="0"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Grid>
        </Box>
      </Box>

      <Grid container spacing={3} mb={3}>
        <Grid item md={6} xs={12}>
          <Typography variant="h6" mb={3}>
            Objection Tracker Notes
          </Typography>
          <TextField
            multiline
            name="objectiontrackernotes"
            {...register("objectiontrackernotes")}
            label="Objection Tracker Notes"
            placeholder="Enter Objection Tracker Notes"
            fullWidth
            rows={6}
            error={!!errors.coursecategoryid}
            helperText={errors.coursecategoryid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            InputLabelProps={{
              shrink: !!watch("objectiontrackernotes"),
            }}
          />
        </Grid>
      </Grid>


      <Typography variant="h5" mb={3}>
        Payment Information
      </Typography>
      <Box sx={{ margin: "15px" }}>
  <Grid item xs={12} md={6}>
    <Controller
      name="paidcourse"
      control={control}
      defaultValue="1" 
      render={({ field }) => (
        <FormControl component="fieldset">
          <RadioGroup
            row
            {...field}
            onChange={(e) => {
              field.onChange(e); 
              setValue("paidcourse", e.target.value);
            }}
            value={field.value ?? "1"} 
          >
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="Paid course"
            />
            <FormControlLabel
              value="0"
              control={<Radio />}
              label="Free course"
            />
          </RadioGroup>
        </FormControl>
      )}
    />
  </Grid>
</Box>
{watch("paidcourse") === "1" &&(<>
      <Grid container spacing={3} mb={3}>


        <Grid item xs={12} md={6}>
          <TextField
            {...register("generalamount", {
              required: "Payment for general Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("generalamount"),
            }}
            error={!!errors.generalamount}
            helperText={errors.generalamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For General Amount
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("nongeneralamount", {
              required: "Payment for non general Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("nongeneralamount"),
            }}
            error={!!errors.nongeneralamount}
            helperText={errors.nongeneralamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For Non General Amount
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("lategeneralamount", {
              // required: "payment for general late fee Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("lategeneralamount"),
            }}
            error={!!errors.lategeneralamount}
            helperText={errors.lategeneralamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For General Late Amount
                {/* <span className="error" style={{ color: "red" }}>
                  *
                </span> */}
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("latenongeneralamount", {
              // // required: "payment for non general late fee Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("latenongeneralamount"),
            }}
            error={!!errors.latenongeneralamount}
            helperText={errors.latenongeneralamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For Non General Late Amount
                {/* <span className="error" style={{ color: "red" }}>
                  *
                </span> */}
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("generalextraamount", {
              // // required: "payment for general extra fee Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("generalextraamount"),
            }}
            error={!!errors.generalextraamount}
            helperText={errors.generalextraamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For General Extra Fee Amount
                {/* <span className="error" style={{ color: "red" }}>
                  *
                </span> */}
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("nongeneralextraamount", {
              // // required: "payment for non general extra fee Amount is required",
            })}
            onInput={NumbersValidation}
            InputLabelProps={{
              shrink: !!watch("nongeneralextraamount"),
            }}
            error={!!errors.nongeneralextraamount}
            helperText={errors.nongeneralextraamount?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Payment For Non General Extra Fee Amount
                {/* <span className="error" style={{ color: "red" }}>
                  *
                </span> */}
              </span>
            }
          />
        </Grid>
      </Grid>
      <Typography variant="h5" mb={3}>
        Billdesk Information
      </Typography>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("billdeskmerchantid", {
              required: "Merchant Id For Billdesk is required",
            })}
            InputLabelProps={{
              shrink: !!watch("billdeskmerchantid"),
            }}
            error={!!errors.billdeskmerchantid}
            helperText={errors.billdeskmerchantid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Merchant Id For Billdesk
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("billdesksecurityid", {
              required: "Merchant Id For PayU is required",
            })}
            InputLabelProps={{
              shrink: !!watch("billdesksecurityid"),
            }}
            error={!!errors.billdesksecurityid}
            helperText={errors.billdesksecurityid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Security Id For Billdesk
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("billdeskclientid", {
              required: "Merchant Id For PayU is required",
            })}
            InputLabelProps={{
              shrink: !!watch("billdeskclientid"),
            }}
            error={!!errors.billdeskclientid}
            helperText={errors.billdeskclientid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Client Id For Billdesk
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
      </Grid>
      <Typography variant="h5" mb={3}>
        PayU Information
      </Typography>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("payumerchantid", {
              required: "Merchant Id For PayU is required",
            })}
            InputLabelProps={{
              shrink: !!watch("payumerchantid"),
            }}
            error={!!errors.payumerchantid}
            helperText={errors.payumerchantid?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Merchant Id For PayU
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            {...register("payusaltkey", {
              required: "Merchant Id For Billdesk is required",
            })}
            InputLabelProps={{
              shrink: !!watch("payusaltkey"),
            }}
            error={!!errors.payusaltkey}
            helperText={errors.payusaltkey?.message}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Salt Key For PayU
                <span className="error" style={{ color: "red" }}>
                  *
                </span>
              </span>
            }
          />
        </Grid>
      </Grid>
      </>)}

      {/* Mock information */}

      <Typography variant="h5" mb={2}>
        Mock Information
      </Typography>



       <Typography variant="body1" mb={1} mt={1}>
        Complimentary Mock
      </Typography>
        <Grid item xs={12} container spacing={2} alignItems="center">
      
      {/* com_bundleid */}
        <Grid item xs={2}>
          <FormControl fullWidth>
            {/* <InputLabel htmlFor="com_bundleid">
              <span style={{ margin: 0, padding: 0, }}>
                Select Bundle
              </span>
            </InputLabel> */}
            <Controller
              name="com_bundleid"
              id="demo-simple-select"
              control={control}
              render={({ field }) => (
                <Select
                  size="small"
                  fullWidth
                  displayEmpty
                  {...field}
                  renderValue={(selected) => {
                    if (!selected) {
                      return <span style={{ color: "#888" }}>Select Bundle</span>;
                    }
                    return mockBundleDetails?.find((x) => x?.bundleid.toString() === selected)?.name;
                  }}
                >
                  <MenuItem key="" value="">
                    None
                  </MenuItem>

                  {mockBundleDetails &&
                    mockBundleDetails.map((obj) => {
                      return (
                        <MenuItem
                          key={obj.bundleid.toString()}
                          value={obj.bundleid.toString()}
                        >
                          {obj.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              )}
            />
          </FormControl>
        </Grid>

        {/* com_maxvalue */}
        <Grid item xs={2}>
          <TextField
            {...register("com_maxvalue")} 
            InputLabelProps={{
              shrink: !!watch("com_maxvalue"),
            }}
            size="small"
            fullWidth
            label={
              <span>
                Max Exam
              </span>
            }
          />
        </Grid>

        {/* com_gst_percent */}
        <Grid item xs={2}>
          <TextField
            {...register("com_gst_percent")} 
            InputLabelProps={{
              shrink: !!watch("com_gst_percent"),
            }}
            size="small"
            fullWidth
            label={
              <span>
                GST in percent
              </span>
            }
          />
        </Grid>

        {/* com_amount */}
        <Grid item xs={2}>
          <TextField 
           {...register("com_amount")} 
            InputLabelProps={{
              shrink: !!watch("com_amount"),
            }}
            size="small"
            fullWidth
            label={
              <span>
                Amount
              </span>
            }
          />
        </Grid>

        {/* com_pack_selection */}
        <Grid item xs={2}>
          <FormControl  fullWidth>
            {/* <InputLabel htmlFor="com_pack_selection"
          
            >
              <span>
                Select Pack
              </span>
            </InputLabel> */}
            <Controller
              name="com_pack_selection"
              id="demo-simple-select"
              FormHelperTextProps={{
                style: { margin: 0 },
              }}
              control={control}
              render={({ field }) => (
                <Select
                  size="small"
                  fullWidth
                  displayEmpty
                  {...field}
renderValue={(selected) => {
  if (selected === "" || selected === null || selected === undefined) {
    return <span style={{ color: "#888" }}>Select Pack</span>;
  }
  return selected === 0 ? "Per Exam" : "Per Pack";
}}
                >
                  <MenuItem key="" value="">
                    None
                  </MenuItem>
                  <MenuItem key="0" value="0">
                    Per Exam
                  </MenuItem>
                  <MenuItem key="1" value="1">
                    Per Pack
                  </MenuItem>
                </Select>
              )}
            />
          </FormControl>
        </Grid>
      </Grid>


       <Typography variant="body1" mb={1} mt={3}>
        Optional Mock
      </Typography>
      <Grid item xs={12} container spacing={2} alignItems="center">
      
      {/* opt_bundleid */}
<Grid item xs={2}>
  <FormControl fullWidth>
    <Controller
      name="opt_bundleid"
      id="demo-simple-select"
      control={control}
      render={({ field }) => (
        <Select
          size="small"
          fullWidth
          displayEmpty
          {...field}
          renderValue={(selected) => {
            if (!selected) {
              return <span style={{ color: "#888" }}>Select Bundle</span>;
            }
            return mockBundleDetails?.find((x) => x?.bundleid.toString() === selected)?.name;
          }}
        >
          <MenuItem value="">
            <span style={{ color: "#888" }}>None</span>
          </MenuItem>

          {mockBundleDetails?.map((obj) => (
            <MenuItem key={obj.bundleid.toString()} value={obj.bundleid.toString()}>
              {obj.name}
            </MenuItem>
          ))}
        </Select>
      )}
    />
  </FormControl>
</Grid>


        {/* opt_maxvalue */}
        <Grid item xs={2}>
          <TextField
            {...register("opt_maxvalue")} 
            InputLabelProps={{
              shrink: !!watch("opt_maxvalue"),
            }}
            size="small"
            fullWidth
            label={
              <span>
                Max Exam
                
              </span>
            }
          />
        </Grid>

        {/* opt_gst_percent */}
        <Grid item xs={2}>
          <TextField
            {...register("opt_gst_percent")} 
            InputLabelProps={{
              shrink: !!watch("opt_gst_percent"),
            }}
            size="small"
            fullWidth
            label={
              <span>
                GST in percent
              </span>
            }
          />
        </Grid>

        {/* opt_amount */}
        <Grid item xs={2}>
          <TextField
            {...register("opt_amount")}
            InputLabelProps={{
              shrink: !!watch("opt_amount"),
            }}
            size="small"
            fullWidth
            label={
              <span>
                Amount
              </span>
            }
          />
        </Grid>

        {/* opt_pack_selection */}
<Grid item xs={2}>
  <FormControl fullWidth>
    <Controller
      name="opt_pack_selection"
      id="demo-simple-select"
      control={control}
      render={({ field }) => (
        <Select
          size="small"
          fullWidth
          displayEmpty
          {...field}
          // renderValue={(selected) => {
          //   if (!selected) {
          //     return <span style={{ color: "#888" }}>Select Pack</span>;
          //   }
          //   return selected === "0" ? "Per Exam" : "Per Pack";
          // }}
          renderValue={(selected) => {
  if (selected === "" || selected === null || selected === undefined) {
    return <span style={{ color: "#888" }}>Select Pack</span>;
  }
  return selected === 0 ? "Per Exam" : "Per Pack";
}}
        >
          <MenuItem value="">
            <span style={{ color: "#888" }}>None</span>
          </MenuItem>
          <MenuItem value="0">Per Exam</MenuItem>
          <MenuItem value="1">Per Pack</MenuItem>
        </Select>
      )}
    />
  </FormControl>
</Grid>

      </Grid>
        
        <Typography variant="body1" mb={1} mt={3}>
        Psychometry Mock
      </Typography>
        <Grid item xs={12} container spacing={2} alignItems="center">
      
      {/* psych_bundleid */}
<Grid item xs={2}>
  <FormControl fullWidth>
    <Controller
      name="psych_bundleid"
      id="demo-simple-select"
      control={control}
      render={({ field }) => (
        <Select
          size="small"
          fullWidth
          displayEmpty
          {...field}
          renderValue={(selected) => {
            if (!selected) {
              return <span style={{ color: "#888" }}>Select Bundle</span>;
            }
            return mockBundleDetails?.find((x) => x?.bundleid.toString() === selected)?.name;
          }}
        >
          <MenuItem value="">
            <span style={{ color: "#888" }}>None</span>
          </MenuItem>

          {mockBundleDetails?.map((obj) => (
            <MenuItem key={obj.bundleid.toString()} value={obj.bundleid.toString()}>
              {obj.name}
            </MenuItem>
          ))}
        </Select>
      )}
    />
  </FormControl>
</Grid>


        {/* psych_maxvalue */}
        <Grid item xs={2}>
          <TextField
            {...register("psych_maxvalue")}
            InputLabelProps={{
              shrink: !!watch("psych_maxvalue"),
            }}
            size="small"
            fullWidth
            label={
              <span>
                Max Exam
              </span>
            }
          />
        </Grid>

        {/* psych_gst_percent */}
        <Grid item xs={2}>
          <TextField
           {...register("psych_gst_percent", {
              // required: " Amount is required",
            })}
            InputLabelProps={{
              shrink: !!watch("psych_gst_percent"),
            }}
            size="small"
            fullWidth
            label={
              <span>
                GST in percent
              </span>
            }
          />
        </Grid>

        {/* psych_amount */}
        <Grid item xs={2}>
          <TextField
            {...register("psych_amount")}
            InputLabelProps={{
              shrink: !!watch("psych_amount"),
            }}
            // error={!!errors.psychamount}
            // helperText={errors.psychamount?.psychmaxvalue}
            FormHelperTextProps={{
              style: { margin: 0 },
            }}
            size="small"
            fullWidth
            label={
              <span>
                Amount
              </span>
            }
          />
        </Grid>

        {/* psych_pack_selection */}
<Grid item xs={2}>
  <FormControl fullWidth>
    <Controller
      name="psych_pack_selection"
      id="demo-simple-select"
      control={control}
      render={({ field }) => (
        <Select
          size="small"
          fullWidth
          displayEmpty
          {...field}
          // renderValue={(selected) => {
          //   if (!selected) {
          //     return <span style={{ color: "#888" }}>Select Pack</span>;
          //   }
          //   return selected === "0" ? "Per Exam" : "Per Pack";
          // }}
          renderValue={(selected) => {
  if (selected === "" || selected === null || selected === undefined) {
    return <span style={{ color: "#888" }}>Select Pack</span>;
  }
  return selected === 0 ? "Per Exam" : "Per Pack";
}}
          FormHelperTextProps={{
            style: { margin: 0 },
          }}
        >
          <MenuItem value="">
            <span style={{ color: "#888" }}>None</span>
          </MenuItem>
          <MenuItem value="0">Per Exam</MenuItem>
          <MenuItem value="1">Per Pack</MenuItem>
        </Select>
      )}
    />
  </FormControl>
</Grid>

      </Grid>



      {/* <Typography variant="h5" mb={3}>
        Eligibility Criteria Information
      </Typography>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} sm={12} md={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 2,
            }}
          >
            <FormControl error={!!errors.eligibilitycriteriaid} fullWidth>
              <InputLabel htmlFor="eligibilitycriteriaid">
                <span>Select Eligibility Criteria</span>
              </InputLabel>
              <Controller
                name="eligibilitycriteriaid"
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                  <Select
                    {...field}
                    multiple
                    value={field.value}
                    onChange={(e) => {
                      const selectedValues = e.target.value;

                      const validValues = selectedValues.filter(
                        (val) => val !== null && val !== undefined
                      );

                      const uniqueValues = Array.from(
                        new Set(validValues.map((val) => val?.toString()))
                      );

                      field.onChange(uniqueValues);
                    }}
                    renderValue={(selected) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value) => {
                          const selectedEligibility = eligibilityCriteria?.find(
                            (lang) =>
                              parseInt(lang.eligibilitycriteriaid) ===
                              parseInt(value)
                          );
                          return (
                            <Chip
                              key={value}
                              label={
                                selectedEligibility?.eligibilitycriterianame ||
                                "Unknown"
                              }
                            />
                          );
                        })}
                      </Box>
                    )}
                    label={<span>Select Eligibility Criteria</span>}
                    labelId="eligibilitycriteriaid"
                    id="eligibilitycriteriaid"
                    error={!!errors.eligibilitycriteriaid}
                    size="small"
                  >
                    <MenuItem value="" disabled>
                      Select Eligibility Criteria
                    </MenuItem>
                    {eligibilityCriteria
                      ?.filter((obj) => obj.isactive === "1")
                      .map((obj) => (
                        <MenuItem
                          key={obj.eligibilitycriteriaid?.toString()}
                          value={obj.eligibilitycriteriaid?.toString()}
                        >
                          {obj.eligibilitycriterianame}
                        </MenuItem>
                      ))}
                  </Select>
                )}
              />
            </FormControl>
          </Box>
          <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
            {errors?.eligibilitycriteriaid?.message}
          </FormHelperText>
        </Grid>
      </Grid> */}

      <Typography variant="h5" mb={1} mt={3}>
        Other Information
      </Typography>
      <Grid container spacing={3} mb={3}>
        {/* <Grid item xs={12} md={6}> 
       <TextField
          {...register("informationbrochure", {
            required: "Information Brochure is required",

          // })}

          // error={!!errors.informationbrochure}
          // helperText={errors.informationbrochure?.message}
          FormHelperTextProps={{
            style: { margin: 0 },
          }}
          size="small"
          fullWidth
          label={
            <span>
              Information Brochure
              <span className="error" style={{ color: "red" }}>
                *
              </span>
            </span>
          }
        /> </Grid> */}
        <Grid item xs={12}>
          {Document?.name !== "" ? (
            <Box
              style={{
                width: "18em",
                height: "45px",
                border: "1px solid #D5D5D5",
                display: "flex",
                alignItems: "center",
                gap: "1%",
                // marginTop: "1rem",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <img
                src={pdf}
                style={{ height: "auto", width: "30px", marginLeft: "5px" }}
                alt="pdf"
              />
              <span
                style={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                }}
              >
                {Document?.name}
              </span>
              <PiX
                style={{ margin: 0, padding: 0, cursor: "pointer" }}
                onClick={handleCloseDocument}
              />
            </Box>
          ) : (
            <>
              <InputLabel sx={{ mb: 1 }} htmlFor="courseFile">
                <span>
                  Upload Brochure
                  <span className="error" style={{ color: "red" }}>
                    *
                  </span>
                </span>
              </InputLabel>
              {/* <BrowseUploadButton
            id="courseFile"
            name="courseFile"
            onChange={handleUpload}
            accept="application/pdf"
            icon={<MdOutlinePictureAsPdf />}
            title={"browse & upload"}
          /> */}

              <Box>
                {Document?.name !== "" ? (
                  <Box
                    pl={2}
                    style={{
                      width: "fit-content",
                      // maxWidth: "18em",
                      height: "45px",
                      border: "1px solid #D5D5D5",
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                      marginTop: "1rem",
                      paddingLeft: "0",
                      // overflow: "hidden",
                      // whiteSpace: "nowrap",
                      // position: 'relative'
                    }}
                  >
                    <Box sx={{ paddingLeft: "10px" }}>{Document?.name}</Box>
                    <Box
                      onClick={() => setDocument({ file: null, name: "" })}
                      sx={{ paddingRight: "10px", cursor: "pointer" }}
                    //  sx={{position: 'absolute', right: 0, width: '1.5rem', paddingLeft: '5px', backgroundColor: `${cssProperties?.backgroundcolor?.secondary}`}}
                    >
                      <PiXBold />
                    </Box>
                  </Box>
                ) : (
                  <Box
                    style={{
                      border: "1px dashed gray",
                      maxWidth: "330px",
                      minHeight: "120px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 340,
                      position: "relative",
                    }}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    <input
                      type="file"
                      name="document"
                      id="document"
                      accept=".jpeg,.jpg,.png,.gif,.pdf"
                      alt=""
                      style={{
                        width: "0.1px",
                        height: "0.1px",
                        opacity: 0,
                        overflow: "hidden",
                        position: "absolute",
                        zIndex: -1,
                      }}
                      // onChange={(e) => handleUpload(e)
                      onChange={(e) => handleUpload(e)}
                    />
                    <label
                      htmlFor="document"
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <IoCloudUploadOutline
                        style={{ marginLeft: "8px" }}
                        size={22}
                      />
                      <span>
                        {" "}
                        &nbsp; Drag or drop your file, or{" "}
                        <span style={{ color: "blue" }}>&nbsp;browse</span>
                      </span>
                      <small style={{ color: "rgb(102, 102, 102)" }}>
                        (JPEG, PNG, GIF and PDF) (5mb max.)
                      </small>
                    </label>
                  </Box>
                )}
                {/* <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: "5px",
                }}
              >
                <small style={{ color: "rgb(102, 102, 102)" }}>
                  Supported file format: JPEG, PNG, GIF and PDF
                </small>
                <small style={{ color: "rgb(102, 102, 102)" }}>
                  Max limit 5mb
                </small>
              </Box> */}
              </Box>
            </>
          )}
          <Box sx={{ width: "100%" }}>
            {documentError.error && (
              <FormHelperText style={{ margin: 0, color: "#d32f2f" }}>
                {documentError?.message}
              </FormHelperText>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <PrintDownloadButton
            startIcon={<MdOutlineEdit />}
            name={"PRE- REQUISITE"}
            handleSubmit={handlePreRequisite}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <CustomSwitch
                {...control}
                name="status"
                {...register("status")}
                checked={watch("status") == 1 ? true : false}
                onChange={(e) => setValue("status", e.target.checked)}
              />
            }
            label="Enable"
          />
        </Grid>
        <Grid
          item
          md={12}
          sx={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}
        >
          <BackButton
            handleBack={() =>
              navigate(
                `/${Cookies.get(
                  "mhet_mst_project"
                )}/course-management?page=courselist`
              )
            }
          />
          <BluePrimaryButton
            handleSubmit={handleSubmit(
              location.search !== "?page=updatecourse"
                ? handleAddCourse
                : handleUpdateCourse
            )}
            title={
              location.search === "?page=updatecourse" ? "Update" : "Submit"
            }
          />
        </Grid>
      </Grid>

      <Prerequesite
        showModal={showPreRequisite?.show}
        handleClose={handleClose}
        setContent={setPreRequisiteContent}
        preRequisiteContent={preRequisiteContent}
      />
      {/* <PreRequisiteModal
        showModal={showPreRequisite?.show}
        handleClose={handleClose}
        setContent={setPreRequisiteContent}
        preRequisiteContent={preRequisiteContent}
      /> */}
      <CreateMasterModal
        // trigger={trigger}
        getValues={getValues}
        register={register}
        // handleSubmit={handleSubmit}
        errors={errors}
        handleCreate={handleAddDrive}
        resetForm={resetForm}
        watch={watch}
      />
      {isDialogOpen && (
        <Dialog open={isDialogOpen} maxWidth="xl" fullWidth>
          <DialogTitle>
            <Box
              mt={2}
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {showIframe && (
                <Typography sx={{ flexGrow: 1, textAlign: "center" }}>
                  Preview AdmitCard
                </Typography>
              )}
              {metadata && (
                <Typography sx={{ flexGrow: 1, textAlign: "center" }}>
                  MetaData
                </Typography>
              )}

              <Box
                sx={{
                  position: "absolute",
                  right: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <button
                  onClick={() => setIsDialogOpen(false)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "40px",
                    height: "40px",
                    cursor: "pointer",
                    background: "none",
                    borderRadius: "50%",
                    border: "1px solid #ccc",
                    cursor: "pointer",
                  }}
                >
                  <IoClose size={16} />
                </button>
              </Box>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Box>
              {showIframe && (
                <iframe
                  src={preview}
                  width="100%"
                  height="600px"
                  style={{ border: "none", marginTop: "10px" }}
                ></iframe>
              )}
              {metadata && (
                <div className="flex justify-center mt-6">
                  <TableContainer
                    component={Paper}
                    sx={{ maxWidth: 800, margin: "auto", marginTop: 4 }}
                  >
                    <Table sx={{ border: "2px solid black" }}>
                      <TableHead>
                        <TableRow sx={{ borderBottom: "2px solid black" }}>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              border: "2px solid black",
                            }}
                          >
                            Field
                          </TableCell>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              border: "2px solid black",
                            }}
                          >
                            Metadata
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(showScoredata ? placeholders1 : placeholders).map(
                          (replacement, index) => (
                            <TableRow
                              key={index}
                              sx={{ borderBottom: "2px solid black" }}
                            >
                              <TableCell sx={{ border: "2px solid black" }}>
                                {replacement?.originalText || "N/A"}
                              </TableCell>
                              <TableCell sx={{ border: "2px solid black" }}>
                                {replacement?.Name || "N/A"}
                              </TableCell>
                            </TableRow>
                          )
                        )}

                        <TableRow sx={{ borderBottom: "2px solid black" }}>
                          <TableCell sx={{ border: "2px solid black" }}>
                            {"<image>"}
                          </TableCell>
                          <TableCell sx={{ border: "2px solid black" }}>
                            {"Photo"}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ borderBottom: "2px solid black" }}>
                          <TableCell sx={{ border: "2px solid black" }}>
                            {"<signature>"}
                          </TableCell>
                          <TableCell sx={{ border: "2px solid black" }}>
                            {"Signature"}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ borderBottom: "2px solid black" }}>
                          <TableCell sx={{ border: "2px solid black" }}>
                            {"<barcode>"}
                          </TableCell>
                          <TableCell sx={{ border: "2px solid black" }}>
                            {"Barcode"}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ borderBottom: "2px solid black" }}>
                          <TableCell
                            sx={{ border: "2px solid black", color: "red" }}
                          >
                            {"ONLY THESE FONT TO USED"}
                          </TableCell>
                          <TableCell
                            sx={{ border: "2px solid black", color: "red" }}
                          >
                            <ul style={{ paddingLeft: "16px", margin: 0 }}>
                              {[
                                "Arial",
                                "Arial Black",
                                "Bahnschrift",
                                "Bahnschrift Condensed",
                                "Bahnschrift Light",
                                "Bahnschrift Light Condensed",
                                "Bahnschrift Light SemiCondensed",
                                "Bahnschrift SemiBold",
                                "Bahnschrift SemiBold Condensed",
                                "Bahnschrift SemiBold SemiCondensed",
                                "Bahnschrift SemiCondensed",
                                "Bahnschrift SemiLight",
                                "Bahnschrift SemiLight Condensed",
                                "Bahnschrift SemiLight SemiCondensed",
                                "Calibri",
                                "Calibri Light",
                                "Cambria",
                                "Candara",
                                "Ebrima",
                                "Franklin Gothic Medium",
                                "Gabriola",
                                "Gadugi",
                                "Georgia",
                                "HoloLens MDL2 Assets",
                                "Impact",
                                "Ink Free",
                                "Javanese Text",
                                "Leelawadee UI",
                                "Leelawadee UI Semilight",
                                "Lucida Console",
                                "Lucida Sans Unicode",
                                "Malgun Gothic",
                                "Microsoft Himalaya",
                                "Microsoft JhengHei",
                                "Microsoft JhengHei Light",
                                "Microsoft JhengHei UI",
                                "Microsoft JhengHei UI Light",
                                "Microsoft New Tai Lue",
                                "Microsoft PhagsPa",
                                "Microsoft Sans Serif",
                                "Microsoft Tai Le",
                                "Microsoft YaHei",
                                "Microsoft YaHei Light",
                                "Microsoft YaHei UI",
                                "Microsoft YaHei UI Light",
                                "Microsoft Yi Baiti",
                                "MingLiU-ExtB",
                                "MingLiU_HKSCS-ExtB",
                                "Mongolian Baiti",
                                "MS Gothic",
                                "MS PGothic",
                                "MS UI Gothic",
                                "MV Boli",
                                "Myanmar Text",
                                "Nirmala UI",
                                "Nirmala UI Semilight",
                                "NSimSun",
                                "Palatino Linotype",
                                "PMingLiU-ExtB",
                                "Segoe MDL2 Assets",
                                "Segoe Print",
                                "Segoe Script",
                                "Segoe UI",
                                "Segoe UI Black",
                                "Segoe UI Emoji",
                                "Segoe UI Historic",
                                "Segoe UI Light",
                                "Segoe UI Semibold",
                                "Segoe UI Semilight",
                                "Segoe UI Symbol",
                                "SimSun",
                                "SimSun-ExtB",
                                "Sitka Banner",
                                "Sitka Display",
                                "Sitka Heading",
                                "Sitka Small",
                                "Sitka Subheading",
                                "Sitka Text",
                                "Sylfaen",
                                "Tahoma",
                                "Times New Roman",
                                "Trebuchet MS",
                                "Verdana",
                                "Yu Gothic",
                                "Yu Gothic Light",
                                "Yu Gothic Medium",
                                "Yu Gothic UI",
                                "Yu Gothic UI Light",
                                "Yu Gothic UI Semibold",
                                "Yu Gothic UI Semilight",
                              ].map((font, index) => (
                                <li key={index} style={{ fontFamily: font }}>
                                  {font}
                                </li>
                              ))}
                            </ul>
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ borderBottom: "2px solid black" }}>
                          <TableCell sx={{ border: "2px solid black" }}>
                            {"For Image"}
                          </TableCell>
                          <TableCell sx={{ border: "2px solid black" }}>
                            {
                              "Need to draw a Text box and inside that meta data to be updated"
                            }
                            <img src={image} />
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ borderBottom: "2px solid black" }}>
                          <TableCell sx={{ border: "2px solid black" }}>
                            {"For Barcode"}
                          </TableCell>
                          <TableCell sx={{ border: "2px solid black" }}>
                            {
                              "Need to draw a Text box and inside that meta data to be updated"
                            }
                            <img src={image} />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              )}
            </Box>
          </DialogContent>
        </Dialog>
      )}
      {/* <div ref={barcodeRef} style={{display:"hidden"}}>
       <Barcode 
  value={filteredResults?.[0]?.rollno} 
  height={150}   
  width={3}     
  displayValue={true} 
/>


    </div> */}
      <div ref={barcodeRef} style={{ display: "none" }}>
        <Barcode
          value={filteredResults?.[0]?.rollno}
          height={150}
          width={3}
          displayValue={true}
        />
      </div>
    </>
  );
}
